import React, { useRef, useState } from "react";
import axios from "axios";
import { useEffect } from "react";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { ExcelExportColumn } from "@progress/kendo-react-excel-export";
import { Button } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import Swal from "sweetalert2";
import StockCountModal from "./StockCountModal";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { Link } from "react-router-dom";

import Spinner from "react-bootstrap/Spinner";
import {
  FaTrashAlt,
  FaFileExport,
  FaAngleDoubleRight,
  FaCalculator,
} from "react-icons/fa";
import Load from "../../../src/assets/img/load.gif";
import { useSelector } from "react-redux";
import BASE_API_URL from "../../api/api";
import apiInstance from "../../Utils/api";
function Stock() {
  const token = localStorage.getItem("token");
  const url = BASE_API_URL;
  // const url = "http://192.168.1.3.:4000/api/";
  const api = apiInstance;

  const scroll = {
    // height: "600px",
    width: "1560px",
    // overflowY: "scroll",
  };
  const Sort = (list) => {
    // console.log(arr,'what')
    setArr(list);
    list.sort(function (a, b) {
      if (a.code.toLowerCase() < b.code.toLowerCase()) return -1;
      if (a.code.toLowerCase() > b.code.toLowerCase()) return 1;
      return 0;
    });
  };

  const [arr, setArr] = useState([]);
  const [accHOItemList, setAccHOItemList] = useState([]);
  const [medHOItemList, setMedHOItemList] = useState([]);
  const [proHOItemList, setProHOItemList] = useState([]);
  const [genHOItemList, setGenHOItemList] = useState([]);
  const [accHOCount, setAccHOCount] = useState("");
  const [medHOCount, setMedHOCount] = useState("");
  const [proHOCount, setProHOCount] = useState("");
  const [genHOCount, setGenHOCount] = useState("");
  const [proEvent, setProEvent] = useState("");
  const [medEvent, setMedEvent] = useState("");
  const [assEvent, setAssEvent] = useState("");

  const [searchProResults, setSearchProResults] = useState([]);
  const [showProSearch, setShowProSearch] = useState(false);
  const [hidePro, setHidePro] = useState(true);
  const [proName, setProName] = useState("");
  const [open, setOpen] = useState(false);

  const [branchID, setBranchID] = useState("");
  // console.log(branchID, "ID");
  const [searchMedResults, setSearchMedResults] = useState([]);
  const [showMedSearch, setShowMedSearch] = useState(false);
  const [hideMed, setHideMed] = useState(true);
  const [medName, setMedName] = useState("");

  const [searchProAccResults, setSearchProAccResults] = useState([]);
  const [showProAccSearch, setShowProAccSearch] = useState(false);
  const [hideProAcc, setHideProAcc] = useState(true);
  const [proAccName, setProAccName] = useState("");

  const [relatedBranch, setRelatedBranch] = useState([]);
  const [showBranch, setShowBranch] = useState(false);

  const [proUnitLists, setProUnitLists] = useState([]);
  const [medUnitLists, setMedUnitLists] = useState([]);
  const [proAssLists, setProAssLists] = useState([]);
  const [showMedicine, setShowMedicine] = useState(true);
  const [showProUnit, setShowProUnit] = useState(false);
  const [showProAss, setShowProAss] = useState(false);

  console.log(proAssLists);
  const [branchesLists, setBranchesLists] = useState([]);
  const [stockLists, setStockLists] = useState([]);
  const [mQty, setMQty] = useState("");

  const [mTotal, setMTotal] = useState("");
  const [mbTotal, setMbTotal] = useState("");

  const [mSell, setMSell] = useState(0);
  const [mPurchase, setMPurchase] = useState(0);

  const [pmQty, setPMQty] = useState("");

  const [pmTotal, setPMTotal] = useState("");
  const [pmSell, setPMSell] = useState(0);
  const [pmPurchase, setPMPurchase] = useState(0);

  const [paQty, setPAQty] = useState("");

  const [paTotal, setPATotal] = useState("");
  const [paSell, setPASell] = useState(0);
  const [paPurchase, setPAPurchase] = useState(0);

  const [proId, setProId] = useState("");
  // const [proName, setProName] = useState('')

  //Med branch

  const [medBranchLists, setMedBranchLists] = useState([]);
  const [showMedBranch, setShowMedBranch] = useState(false);

  //Pro Branch
  const [proBranchLists, setProBranchLists] = useState([]);
  const [showProBranch, setShowProBranch] = useState(false);

  //Pro Acc Branch
  const [proAccBranchLists, setProAccBranchLists] = useState([]);
  const [showProAccBranch, setShowProAccBranch] = useState(false);

  const [hO, setHO] = useState("");

  //Med Select
  const [medHOCheckList, setMedHOCheckList] = useState([]);

  //Pro Select
  const [proHOCheckList, setProHOCheckList] = useState([]);

  //Pro Ass Select
  const [proAssHOCheckList, setProAssHOCheckList] = useState([]);
  const [proTotal, setProTotal] = useState("");
  const [proAssTotal, setProAssTotal] = useState("");

  //General
  const [showGeneral, setShowGeneral] = useState(false);
  const [generalTable, setGeneralTable] = useState(false);
  const [generalBranch, setGeneralBranch] = useState(false);
  const [generalLists, setGeneralLists] = useState([]);
  const [generalTotal, setGeneralTotal] = useState("");
  const [searchGeneralResults, setSearchGeneralResults] = useState([]);
  const [showGeneralSearch, setShowGeneralSearch] = useState(false);
  const [generalHOCheckList, setGeneralHOCheckList] = useState([]);
  const [genSell, setGenSell] = useState("");
  const [genPurchase, setGenPurchase] = useState("");
  const [generalBranchLists, setGeneralBranchLists] = useState([]);
  const [hideGen, setHideGen] = useState(true);
  const [medTotal, setMedTotal] = useState("");

  const ButtonStyle = { margin: "10px 10px" };
  const ErrorColor = { border: "red" };
  const handleMedCheck = (event, medUnit, type) => {
    if (event.target.checked) {
      setMedHOCheckList([
        ...medHOCheckList,
        medUnitLists.filter((data) => data._id === medUnit._id)[0],
      ]);
    } else {
      setMedHOCheckList((prevValue) =>
        prevValue.filter((data) => data._id !== medUnit._id),
      );
    }

    // console.log(
    //   [
    //     ...medHOCheckList,
    //     medHOItemList.filter(data => data._id === medUnit._id)[0]
    //   ],
    //   'id list'
    // )

    // setIsChecked(!isChecked)
  };

  const handleProCheck = (event, proUnit, type) => {
    if (event.target.checked) {
      setProHOCheckList([
        ...proHOCheckList,
        proUnitLists.filter((data) => data._id === proUnit._id)[0],
      ]);
    } else {
      setProHOCheckList((prevValue) =>
        prevValue.filter((data) => data._id !== proUnit._id),
      );
    }
  };
  const handleProSelectAll = (event, proUnit, type) => {
    if (event.target.checked) {
      setProHOCheckList(proUnit);
    }
  };
  const handleMedSelectAll = (event, medUnit, type) => {
    if (event.target.checked) {
      setMedHOCheckList(medUnit);
    }
  };
  const handleGenSelectAll = (event, genUnit, type) => {
    if (event.target.checked) {
      setGeneralHOCheckList(genUnit);
    }
  };

  const handleAccSelectAll = (event, accUnit, type) => {
    if (event.target.checked) {
      setProAssHOCheckList(accUnit);
    }
  };

  const handleProAssCheck = (event, proUnit, type) => {
    if (event.target.checked) {
      setProAssHOCheckList([
        ...proAssHOCheckList,
        proAssLists.filter((data) => data._id === proUnit._id)[0],
      ]);
    } else {
      setProAssHOCheckList((prevValue) =>
        prevValue.filter((data) => data._id !== proUnit._id),
      );
    }
  };

  const handleGeneralCheck = (event, genUnit, type) => {
    if (event.target.checked) {
      setGeneralHOCheckList([
        ...generalHOCheckList,
        generalLists.filter((data) => data._id === genUnit._id)[0],
      ]);
    } else {
      setGeneralHOCheckList((prevValue) =>
        prevValue.filter((data) => data._id !== genUnit._id),
      );
    }
  };

  const handleUpdateUnitCalculation = (event, proUnit, type) => {
    // console.log(qty, 'qty')
    // console.log(event, 'event')

    if (type === "currentQuantity") {
      let uQty = parseInt(event);
      let total = event * proUnit.toUnit;
      // console.log(uQty);
      // console.log(total);
      setPMTotal(total);
      setPMQty(event);

      const newData = proUnitLists.map((data) => {
        if (data._id === proUnit._id) {
          return { ...data, [type]: event, totalUnit: total };
        }
        return data;
      });

      // console.log(newData);
      setProUnitLists(newData);
    } else if (type === "toUnit") {
      let total = event * proUnit.currentQuantity;
      setPMTotal(total);
      // console.log(total);
      const newData = proUnitLists.map((data) => {
        if (data._id === proUnit._id) {
          return { ...data, [type]: event, totalUnit: total };
        }
        return data;
      });
      // console.log(newData);
      setProUnitLists(newData);
    }
  };
  const handleUpdateSearchUnitCalculation = (event, proUnit, type) => {
    // console.log(qty, 'qty')
    // console.log(event, 'event')handlePAUpdateUnitCalculation

    if (type === "currentQuantity") {
      let uQty = parseInt(event);
      let total = event * proUnit?.toUnit;
      // console.log(uQty);
      // console.log(total);
      setPMTotal(total);
      setPMQty(event);

      const newData = searchProResults.map((data) => {
        if (data._id === proUnit._id) {
          return { ...data, [type]: event, totalUnit: total };
        }
        return data;
      });

      // console.log(newData);
      setSearchProResults(newData);
    } else if (type === "toUnit") {
      let total = event * proUnit.currentQuantity;
      setPMTotal(total);
      // console.log(total);
      const newData = searchProResults.map((data) => {
        if (data._id === proUnit._id) {
          return { ...data, [type]: event, totalUnit: total };
        }
        return data;
      });
      // console.log(newData);
      setSearchProResults(newData);
    }
  };

  const handleMUpdateUnitCalculation = (event, medUnit, type) => {
    // console.log(medUnit.toUnit, "event");

    if (type === "currentQuantity") {
      let uQty = parseInt(event);
      let total = event * medUnit.toUnit;
      // console.log(uQty);
      // console.log(total);
      setMTotal(total);
      setMQty(event);
      const newData = medUnitLists.map((data) => {
        if (data._id === medUnit._id) {
          return { ...data, [type]: event, totalUnit: total };
        }
        return data;
      });
      // console.log(newData, "med");
      setMedUnitLists(newData);
    } else if (type === "toUnit") {
      let total = event * medUnit.currentQuantity;
      setMTotal(total);
      // console.log(total);
      const newData = medUnitLists.map((data) => {
        if (data._id === medUnit._id) {
          return { ...data, [type]: event, totalUnit: total };
        }
        return data;
      });
      // console.log(newData);
      setMedUnitLists(newData);
    }
  };

  const handleMSearchUpdateUnitCalculation = (event, medUnit, type) => {
    // console.log(qty, 'qty')
    // console.log(event, 'event')

    if (type === "currentQuantity") {
      let uQty = parseInt(event);
      let total = event * medUnit.toUnit;
      // console.log(uQty);
      // console.log(total);
      setMTotal(total);
      setMQty(event);
      const newData = searchMedResults.map((data) => {
        if (data._id === medUnit._id) {
          return { ...data, [type]: event, totalUnit: total };
        }
        return data;
      });
      // console.log(newData);
      setSearchMedResults(newData);
    } else if (type === "toUnit") {
      let total = event * medUnit.currentQuantity;
      setMTotal(total);
      // console.log(total);
      const newData = searchMedResults.map((data) => {
        if (data._id === medUnit._id) {
          return { ...data, [type]: event, totalUnit: total };
        }
        return data;
      });
      // console.log(newData);
      setSearchMedResults(newData);
    }
  };

  const handlePAUpdateUnitCalculation = (event, paUnit, type) => {
    // console.log(qty, 'qty')
    console.log(paUnit.toUnit, "to unit");

    if (type === "currentQuantity") {
      let uQty = parseInt(event);
      let total = event * paUnit.toUnit;
      // console.log(uQty);
      // console.log(total);
      setPATotal(total);
      setPAQty(event);
      const newData = proAssLists.map((data) => {
        if (data._id === paUnit._id) {
          return { ...data, [type]: event, totalUnit: total };
        }
        return data;
      });
      // console.log(newData);
      setProAssLists(newData);
    } else if (type === "toUnit") {
      let total = event * paUnit.currentQuantity;
      setPATotal(total);
      // console.log(total);
      const newData = proAssLists.map((data) => {
        if (data._id === paUnit._id) {
          return { ...data, [type]: event, totalUnit: total };
        }
        return data;
      });
      // console.log(newData);
      setProAssLists(newData);
    }
  };

  const handlePASearchUpdateUnitCalculation = (event, paUnit, type) => {
    // console.log(qty, 'qty')
    // console.log(paUnit.toUnit, "to unit");

    if (type === "currentQuantity") {
      let uQty = parseInt(event);
      let total = event * paUnit.toUnit;
      // console.log(uQty);
      // console.log(total);
      setPATotal(total);
      setPAQty(event);
      const newData = searchProAccResults.map((data) => {
        if (data._id === paUnit._id) {
          return { ...data, [type]: event, totalUnit: total };
        }
        return data;
      });
      // console.log(newData);
      setSearchProAccResults(newData);
    } else if (type === "toUnit") {
      let total = event * paUnit.currentQuantity;
      setPATotal(total);
      // console.log(total);
      const newData = searchProAccResults.map((data) => {
        if (data._id === paUnit._id) {
          return { ...data, [type]: event, totalUnit: total };
        }
        return data;
      });
      // console.log(newData);
      setSearchProAccResults(newData);
    }
  };

  const handleGeneralUpdateUnitCalculation = (event, genUnit, type) => {
    // console.log(qty, 'qty')
    console.log(genUnit.currentQuantity, "qty");

    if (type === "currentQuantity") {
      let uQty = parseInt(event);
      let total = event * genUnit.toUnit;
      // console.log(uQty);
      // console.log(total);
      setPATotal(total);
      setPAQty(event);
      const newData = generalLists.map((data) => {
        if (data._id === genUnit._id) {
          return { ...data, [type]: event, totalUnit: total };
        }
        return data;
      });

      setGeneralLists(newData);
      // console.log(newData, "da");
    } else if (type === "toUnit") {
      let total = event * genUnit.currentQuantity;
      setPATotal(total);
      // console.log(total);
      const newData = generalLists.map((data) => {
        if (data._id === genUnit._id) {
          return { ...data, [type]: event, totalUnit: total };
        }
        return data;
      });
      // console.log(newData);
      setGeneralLists(newData);
      // console.log(newData, "to");
    }
  };

  const handleGeneralSearchUpdateUnitCalculation = (event, genUnit, type) => {
    // console.log(qty, 'qty')
    // console.log(genUnit.currentQuantity, "qty");

    if (type === "currentQuantity") {
      let uQty = parseInt(event);
      let total = event * genUnit.toUnit;
      // console.log(uQty);
      // console.log(total);
      setPATotal(total);
      setPAQty(event);
      const newData = searchGeneralResults.map((data) => {
        if (data._id === genUnit._id) {
          return { ...data, [type]: event, totalUnit: total };
        }
        return data;
      });

      setSearchGeneralResults(newData);
      // console.log(newData, "da");
    } else if (type === "toUnit") {
      let total = event * genUnit.currentQuantity;
      setPATotal(total);
      // console.log(total);
      const newData = searchGeneralResults.map((data) => {
        if (data._id === genUnit._id) {
          return { ...data, [type]: event, totalUnit: total };
        }
        return data;
      });
      // console.log(newData);
      setSearchGeneralResults(newData);
      // console.log(newData, "to");
    }
  };

  const prevToUnitRef = useRef(null);
  const prevPMToUnitRef = useRef(null);
  const prevPAToUnitRef = useRef(null);
  const prevGeneralToUnitRef = useRef(null);

  const handlePMUpdate = (proUnit) => {
    const oldValue = prevPMToUnitRef.current;

    if (oldValue !== null && Number(proUnit.toUnit) !== Number(oldValue)) {
      Swal.fire({
        title: "Confirm toUnit Change",
        text: `This change will cause stock changes. Are you sure you want to continue?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        if (!result.isConfirmed) {
          prevPMToUnitRef.current = null;
          return;
        }

        const data = {
          id: proUnit._id,
          currentQuantity: proUnit.currentQuantity,
          fromUnit: proUnit.fromUnit,
          toUnit: proUnit.toUnit,
          totalUnit: proUnit.currentQuantity * proUnit.toUnit,
        };

        if (mPurchase > 0) {
          data.purchasePrice = parseInt(mPurchase);
        }
        if (mSell > 0) {
          data.sellingPrice = parseInt(mSell);
        }

        const config = {
          headers: { "Content-Type": "application/json" },
        };

        api
          .put("procedure-item", data, config)
          .then(function (response) {
            Swal.fire({
              title: "Successful!",
              text: "Successfully Updated",
              icon: "success",
              cancelButtonText: "Close",
            });
            prevPMToUnitRef.current = null;
          })
          .catch(function (err) {
            Swal.fire({
              title: "Something Wrong!",
              text: "Try again, Please.",
              icon: "warning",
              cancelButtonText: "Close",
            });
            prevPMToUnitRef.current = null;
          });
      });
      return;
    }
    const data = {
      id: proUnit._id,
      currentQuantity: proUnit.currentQuantity,
      fromUnit: proUnit.fromUnit,
      toUnit: proUnit.toUnit,
      totalUnit: proUnit.currentQuantity * proUnit.toUnit,
    };

    if (pmPurchase > 0) {
      data.purchasePrice = parseInt(pmPurchase);
    }
    if (pmSell > 0) {
      data.sellingPrice = parseInt(pmSell);
    }

    // alert(JSON.stringify(data))

    const config = {
      headers: { "Content-Type": "application/json" },
    };

    api
      .put("procedure-item", data, config)

      .then(function (response) {
        // console.log(response.data);
        Swal.fire({
          title: "Successful!",
          text: "Successfully Updated",
          icon: "success",

          cancelButtonText: "Close",
        });
        prevPMToUnitRef.current = null;
        //         // window.location.reload()

        //         // setUnitLists([...unitLists,response.data.list])

        //         // setUnitLists(
        //         //   unitLists.map(category => {
        //         //     if (category._id === response.data.list._id) {
        //         //       return response.data.list
        //         //     } else {
        //         //       return category
        //         //     }
        //         //   })
        //         // )
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
        prevPMToUnitRef.current = null;
      });
    // document.getElementById('desc').value = ''
    // document.getElementById('name').value = ''
    // document.getElementById('code').value = ''
  };

  const handleMUpdate = (medUnit) => {
    const oldValue = prevToUnitRef.current;

    if (oldValue !== null && Number(medUnit.toUnit) !== Number(oldValue)) {
      Swal.fire({
        title: "Confirm toUnit Change",
        text: `This change will cause stock changes. Are you sure you want to continue?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        if (!result.isConfirmed) {
          prevToUnitRef.current = null;
          return;
        }

        const data = {
          id: medUnit._id,
          currentQuantity: medUnit.currentQuantity,
          fromUnit: medUnit.fromUnit,
          toUnit: medUnit.toUnit,
          totalUnit: medUnit.currentQuantity * medUnit.toUnit,
        };

        if (mPurchase > 0) {
          data.purchasePrice = parseInt(mPurchase);
        }
        if (mSell > 0) {
          data.sellingPrice = parseInt(mSell);
        }

        const config = {
          headers: { "Content-Type": "application/json" },
        };

        api
          .put("medicine-item", data, config)
          .then(function (response) {
            Swal.fire({
              title: "Successful!",
              text: "Successfully Updated",
              icon: "success",
              cancelButtonText: "Close",
            });
            prevToUnitRef.current = null;
          })
          .catch(function (err) {
            Swal.fire({
              title: "Something Wrong!",
              text: "Try again, Please.",
              icon: "warning",
              cancelButtonText: "Close",
            });
            prevToUnitRef.current = null;
          });
      });
      return;
    }

    const data = {
      id: medUnit._id,
      currentQuantity: medUnit.currentQuantity,
      fromUnit: medUnit.fromUnit,
      toUnit: medUnit.toUnit,
      totalUnit: medUnit.currentQuantity * medUnit.toUnit,
    };

    if (mPurchase > 0) {
      data.purchasePrice = parseInt(mPurchase);
    }
    if (mSell > 0) {
      data.sellingPrice = parseInt(mSell);
    }

    const config = {
      headers: { "Content-Type": "application/json" },
    };

    api
      .put("medicine-item", data, config)
      .then(function (response) {
        Swal.fire({
          title: "Successful!",
          text: "Successfully Updated",
          icon: "success",
          cancelButtonText: "Close",
        });
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          cancelButtonText: "Close",
        });
      });
  };

  // const showID=(val)=>{
  //   console.log(val,'med id')
  // }
  const handlePAUpdate = (paUnit) => {
    const oldValue = prevPAToUnitRef.current;

    if (oldValue !== null && Number(paUnit.toUnit) !== Number(oldValue)) {
      Swal.fire({
        title: "Confirm toUnit Change",
        text: `This change will cause stock changes. Are you sure you want to continue?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        if (!result.isConfirmed) {
          prevPAToUnitRef.current = null;
          return;
        }

        const data = {
          id: paUnit._id,
          currentQuantity: paUnit.currentQuantity,
          fromUnit: paUnit.fromUnit,
          toUnit: paUnit.toUnit,
          totalUnit: paUnit.currentQuantity * paUnit.toUnit,
        };

        if (mPurchase > 0) {
          data.purchasePrice = parseInt(mPurchase);
        }
        if (mSell > 0) {
          data.sellingPrice = parseInt(mSell);
        }

        const config = {
          headers: { "Content-Type": "application/json" },
        };

        api
          .put("accessory-item", data, config)
          .then(function (response) {
            Swal.fire({
              title: "Successful!",
              text: "Successfully Updated",
              icon: "success",
              cancelButtonText: "Close",
            });
            prevPAToUnitRef.current = null;
          })
          .catch(function (err) {
            Swal.fire({
              title: "Something Wrong!",
              text: "Try again, Please.",
              icon: "warning",
              cancelButtonText: "Close",
            });
            prevPAToUnitRef.current = null;
          });
      });
      return;
    }
    //console.log(proId,'pro')
    const data = {
      id: paUnit._id,
      currentQuantity: paUnit.currentQuantity,
      fromUnit: paUnit.fromUnit,
      toUnit: paUnit.toUnit,
      totalUnit: paUnit.currentQuantity * paUnit.toUnit,
    };

    if (paPurchase > 0) {
      data.purchasePrice = parseInt(paPurchase);
    }
    if (paSell > 0) {
      data.sellingPrice = parseInt(paSell);
    }

    // alert(JSON.stringify(data))

    const config = {
      headers: { "Content-Type": "application/json" },
    };

    api
      .put("accessory-item", data, config)

      .then(function (response) {
        // console.log(response.data);
        Swal.fire({
          title: "Successful!",
          text: "Successfully Updated",
          icon: "success",

          cancelButtonText: "Close",
        });
        prevPAToUnitRef.current = null;
        //         // window.location.reload()

        //         // setUnitLists([...unitLists,response.data.list])

        //         // setUnitLists(
        //         //   unitLists.map(category => {
        //         //     if (category._id === response.data.list._id) {
        //         //       return response.data.list
        //         //     } else {
        //         //       return category
        //         //     }
        //         //   })
        //         // )
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
        prevPAToUnitRef.current = null;
      });
    // document.getElementById('desc').value = ''
    // document.getElementById('name').value = ''
    // document.getElementById('code').value = ''
  };

  const handleGeneralUpdate = (genUnit) => {
    const oldValue = prevGeneralToUnitRef.current;

    if (oldValue !== null && Number(genUnit.toUnit) !== Number(oldValue)) {
      Swal.fire({
        title: "Confirm toUnit Change",
        text: `This change will cause stock changes. Are you sure you want to continue?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        if (!result.isConfirmed) {
          prevGeneralToUnitRef.current = null;
          return;
        }

        const data = {
          id: genUnit._id,
          currentQuantity: genUnit.currentQuantity,
          fromUnit: genUnit.fromUnit,
          toUnit: genUnit.toUnit,
          totalUnit: genUnit.currentQuantity * genUnit.toUnit,
        };

        if (mPurchase > 0) {
          data.purchasePrice = parseInt(mPurchase);
        }
        if (mSell > 0) {
          data.sellingPrice = parseInt(mSell);
        }

        const config = {
          headers: { "Content-Type": "application/json" },
        };

        api
          .put("general-item", data, config)
          .then(function (response) {
            Swal.fire({
              title: "Successful!",
              text: "Successfully Updated",
              icon: "success",
              cancelButtonText: "Close",
            });
            prevGeneralToUnitRef.current = null;
          })
          .catch(function (err) {
            Swal.fire({
              title: "Something Wrong!",
              text: "Try again, Please.",
              icon: "warning",
              cancelButtonText: "Close",
            });
            prevGeneralToUnitRef.current = null;
          });
      });
      return;
    }
    const data = {
      id: genUnit._id,
      currentQuantity: genUnit.currentQuantity,
      fromUnit: genUnit.fromUnit,
      toUnit: genUnit.toUnit,
      totalUnit: genUnit.currentQuantity * genUnit.toUnit,
    };

    if (genPurchase > 0) {
      data.purchasePrice = parseInt(genPurchase);
    }
    if (genSell > 0) {
      data.sellingPrice = parseInt(genSell);
    }

    // alert(JSON.stringify(data))

    const config = {
      headers: { "Content-Type": "application/json" },
    };

    api
      .put("general-item", data, config)

      .then(function (response) {
        // console.log(response.data);
        Swal.fire({
          title: "Successful!",
          text: "Successfully Updated",
          icon: "success",

          cancelButtonText: "Close",
        });
        prevGeneralToUnitRef.current = null;
        //         // window.location.reload()

        //         // setUnitLists([...unitLists,response.data.list])

        //         // setUnitLists(
        //         //   unitLists.map(category => {
        //         //     if (category._id === response.data.list._id) {
        //         //       return response.data.list
        //         //     } else {
        //         //       return category
        //         //     }
        //         //   })
        //         // )
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
        prevGeneralToUnitRef.current = null;
      });
    // document.getElementById('desc').value = ''
    // document.getElementById('name').value = ''
    // document.getElementById('code').value = ''
  };

  const _export1 = React.useRef(null);
  const _export2 = React.useRef(null);
  const _export3 = React.useRef(null);
  const _export4 = React.useRef(null);

  const excelExport1 = () => {
    if (_export1.current !== null) {
      // console.log(_export1.current.props.data, 'excel')

      _export1.current.props.data.map(function (element, index) {
        element.code = element.code;
      });

      _export1.current.save();
    }
  };

  const excelExport2 = () => {
    if (_export2.current !== null) {
      // console.log(_export2.current.props.data, 'excel')

      _export2.current.props.data.map(function (element, index) {
        element.code = element.code;
      });

      _export2.current.save();
    }
  };

  const excelExport3 = () => {
    if (_export3.current !== null) {
      // console.log(_export3.current.props.data, 'excel')
      _export3.current.props.data.map(function (element, index) {
        element.code = element.code;
      });
      _export3.current.save();
    }
  };

  const excelExport4 = () => {
    if (_export4.current !== null) {
      _export4.current.props.data.map(function (element, index) {
        element.code = element.code;
      });
      _export4.current.save();
    }
  };

  useEffect(() => {
    const getProUnitLists = async () => {
      try {
        const res = await api.get("procedure-items?limit=30");

        setProUnitLists(
          res.data.list.sort(function (a, b) {
            if (a.code.toLowerCase() < b.code.toLowerCase()) return -1;
            if (a.code.toLowerCase() > b.code.toLowerCase()) return 1;
            return 0;
          }),
        );
        // console.log(res.data.list, 'prounit l')
        // console.log(setProUnitLists.reOrderQuantity)
        const totalPrice = res.data.list.reduce(
          (accumulator, currentValue) =>
            accumulator +
            currentValue.purchasePrice * currentValue.currentQuantity,
          0,
        );
        setProTotal(totalPrice);
        // console.log(totalPrice, 'total')

        setProId(res.data.list._id);
      } catch (err) {
        alert(err.message);
      }
    };

    const getMedUnitLists = async () => {
      try {
        const res = await api.get("medicine-items");
        const totalPrice = res.data.list.reduce(
          (accumulator, currentValue) =>
            accumulator +
            currentValue.purchasePrice * currentValue.currentQuantity,
          0,
        );
        setMedTotal(totalPrice);
        Sort(res.data.list);
        setMedUnitLists(res.data.list);
        // console.log(arr,'meddddd')
        //         console.log(res.data.list.sort(function(a, b) {
        //   if(a.code.toLowerCase() < b.code.toLowerCase()) return -1;
        //   if(a.code.toLowerCase() > b.code.toLowerCase()) return 1;
        //   return 0;
        //  }), 'ori me list')
      } catch (err) {
        alert(err.message);
      }
    };

    const getBranches = async () => {
      try {
        const res = await api.get("branches");
        setBranchesLists(res.data.list);
      } catch (err) {
        alert(err.message);
      }
    };

    const getProAssLists = async () => {
      try {
        const res = await api.get("accessory-items?limit=30");
        setProAssLists(
          res.data.list.sort(function (a, b) {
            if (a.code.toLowerCase() < b.code.toLowerCase()) return -1;
            if (a.code.toLowerCase() > b.code.toLowerCase()) return 1;
            return 0;
          }),
        );
        const totalPrice = res.data.list.reduce(
          (accumulator, currentValue) =>
            accumulator +
            currentValue.purchasePrice * currentValue.currentQuantity,
          0,
        );
        setProAssTotal(totalPrice);

        // console.log(res.data.list, 'pro ass')
      } catch (err) {
        alert(err.message);
      }
    };

    const getGeneralLists = async () => {
      try {
        const res = await api.get("general-items");
        setGeneralLists(
          res.data.list.sort(function (a, b) {
            if (a.code.toLowerCase() < b.code.toLowerCase()) return -1;
            if (a.code.toLowerCase() > b.code.toLowerCase()) return 1;
            return 0;
          }),
        );
        // console.log(res.data.list)

        const totalPrice = res.data.list.reduce(
          (accumulator, currentValue) =>
            accumulator +
            currentValue.purchasePrice * currentValue.currentQuantity,
          0,
        );
        // console.log(totalPrice, 'gen li')
        setGeneralTotal(totalPrice);
      } catch (err) {
        alert(err.message);
      }
    };

    const getPurchaseLists = async () => {
      try {
        const res = await api.get(
          "purchase-requests",
          //'http://localhost:9000/api/treatments'
        );

        setMedHOItemList(
          res.data.list
            .filter((el) => el.relatedApprove && el.medicineItems[0])
            .filter(
              (i) =>
                i.medicineItems.filter(
                  (e) =>
                    new Date(e.alertDate).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }) ===
                    new Date().toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }),
                )[0],
            ),
        );
        setProHOItemList(
          res.data.list
            .filter((el) => el.relatedApprove && el.procedureItems[0])
            .filter(
              (i) =>
                i.procedureItems.filter(
                  (e) =>
                    new Date(e.alertDate).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }) ===
                    new Date().toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }),
                )[0],
            ),
        );
        setAccHOItemList(
          res.data.list
            .filter((el) => el.relatedApprove && el.accessoryItems[0])
            .filter(
              (i) =>
                i.accessoryItems.filter(
                  (e) =>
                    new Date(e.alertDate).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }) ===
                    new Date().toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }),
                )[0],
            ),
        );
        setGenHOItemList(
          res.data.list
            .filter((el) => el.relatedApprove && el.generalItems[0])
            .filter(
              (i) =>
                i.generalItems.filter(
                  (e) =>
                    new Date(e.alertDate).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }) ===
                    new Date().toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }),
                )[0],
            ),
        );
        setMedHOCount(
          res.data.list
            .filter((el) => el.relatedApprove && el.medicineItems[0])
            .filter(
              (i) =>
                i.medicineItems.filter(
                  (e) =>
                    new Date(e.alertDate).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }) ===
                    new Date().toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }),
                )[0],
            ).length,
        );
        setProHOCount(
          res.data.list
            .filter((el) => el.relatedApprove && el.procedureItems[0])
            .filter(
              (i) =>
                i.procedureItems.filter(
                  (e) =>
                    new Date(e.alertDate).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }) ===
                    new Date().toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }),
                )[0],
            ).length,
        );
        setAccHOCount(
          res.data.list
            .filter((el) => el.relatedApprove && el.accessoryItems[0])
            .filter(
              (i) =>
                i.accessoryItems.filter(
                  (e) =>
                    new Date(e.alertDate).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }) ===
                    new Date().toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }),
                )[0],
            ).length,
        );
        setGenHOCount(
          res.data.list
            .filter((el) => el.relatedApprove && el.generalItems[0])
            .filter(
              (i) =>
                i.generalItems.filter(
                  (e) =>
                    new Date(e.alertDate).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }) ===
                    new Date().toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }),
                )[0],
            ).length,
        );
      } catch (err) {
        alert(err.message);
      }
    };
    getPurchaseLists();
    getGeneralLists();
    getProAssLists();
    getBranches();

    getMedUnitLists();
    getProUnitLists();
  }, []);

  const handleFilterDate = () => { };
  //med bran del
  const handleDelMed = (id) => {
    api
      .delete("stock/" + id)
      .then((response) => {
        Swal.fire({
          title: "Success",
          text: "Successfully Deleted!",
          icon: "success",
          confirmButtonText: "OK",
        });
        const result = medBranchLists.filter((item) => item._id !== id);
        setMedBranchLists(result);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error.response.data.message,
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      });
  };
  const submitMed = (id) => {
    confirmAlert({
      title: "Confirm to delete!",
      message: "Are you sure to do this?",
      buttons: [
        {
          label: "Yes",
          onClick: () => handleDelMed(id),
        },
        {
          label: "No",
          //onClick: () => alert('Click No')
        },
      ],
    });
  };

  //pro branch del
  const handleDelPro = (id) => {
    api
      .delete("stock/" + id)
      .then((response) => {
        Swal.fire({
          title: "Success",
          text: "Successfully Deleted!",
          icon: "success",
          confirmButtonText: "OK",
        });
        const result = proBranchLists.filter((item) => item._id !== id);
        setProBranchLists(result);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error.response.data.message,
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      });
  };

  const submitPro = (id) => {
    confirmAlert({
      title: "Confirm to delete!",
      message: "Are you sure to do this?",
      buttons: [
        {
          label: "Yes",
          onClick: () => handleDelPro(id),
        },
        {
          label: "No",
          //onClick: () => alert('Click No')
        },
      ],
    });
  };

  //pro acc branch del
  const handleDelProAss = (id) => {
    api
      .delete("stock/" + id)
      .then((response) => {
        Swal.fire({
          title: "Success",
          text: "Successfully Deleted!",
          icon: "success",
          confirmButtonText: "OK",
        });
        const result = proAccBranchLists.filter((item) => item._id !== id);
        setProAccBranchLists(result);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error.response.data.message,
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      });
  };

  const submitProAss = (id) => {
    confirmAlert({
      title: "Confirm to delete!",
      message: "Are you sure to do this?",
      buttons: [
        {
          label: "Yes",
          onClick: () => handleDelProAss(id),
        },
        {
          label: "No",
          //onClick: () => alert('Click No')
        },
      ],
    });
  };

  //pro acc branch del
  const handleDelGen = (id) => {
    api
      .delete("stock/" + id)
      .then((response) => {
        Swal.fire({
          title: "Success",
          text: "Successfully Deleted!",
          icon: "success",
          confirmButtonText: "OK",
        });
        const result = generalBranchLists.filter((item) => item._id !== id);
        setGeneralBranchLists(result);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error.response.data.message,
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      });
  };

  const generalSearch = (event) => {
    // console.log(event, "name");
    if (event) {
      setSearchGeneralResults(
        generalLists.filter(
          (el) =>
            (el.generalItemName ? el.generalItemName : "")
              .toLowerCase()
              .includes(event.toLowerCase()) ||
            (el.name ? el.name.relatedBrand.name : "")
              .toLowerCase()
              .includes(event.toLowerCase()) ||
            (el.code ? el.code : "")
              .toLowerCase()
              .includes(event.toLowerCase()),
        ),
      );

      setShowGeneralSearch(true);
      setGeneralTable(false);
    } else {
      setShowGeneralSearch(false);
      setGeneralTable(true);
    }
  };

  const proSearch = (event) => {
    setProEvent(event);
    if (event) {
      setShowProSearch(true);
      setHidePro(false);
      setSearchProResults(
        proUnitLists.filter(
          (el) =>
            (el.procedureItemName ? el.procedureItemName : "")
              .toLowerCase()
              .includes(event.toLowerCase()) ||
            (el.name ? el.name.relatedBrand.name : "")
              .toLowerCase()
              .includes(event.toLowerCase()) ||
            (el.code ? el.code : "")
              .toLowerCase()
              .includes(event.toLowerCase()),
        ),
      );
    } else {
      setShowProSearch(false);
      setHidePro(true);
    }
  };
  const medSearch = (medName) => {
    setMedEvent(medName);

    if (medName) {
      setSearchMedResults(
        medUnitLists.filter(
          (el) =>
            (el?.medicineItemName)
              .toLowerCase()
              .includes(medName.toLowerCase()) ||
            (el.name ? el.name.relatedBrand.name : "")
              .toLowerCase()
              .includes(medName.toLowerCase()) ||
            (el?.code).toLowerCase().includes(medName.toLowerCase()),
        ),
      );
      // console.log(
      //   medUnitLists.filter(
      //     (el) =>
      //       (el?.medicineItemName)
      //         .toLowerCase()
      //         .includes(medName.toLowerCase()) ||
      //       (el.name ? el.name.relatedBrand.name : "")
      //         .toLowerCase()
      //         .includes(medName.toLowerCase()) ||
      //       (el?.code).toLowerCase().includes(medName.toLowerCase())
      //   )
      // );

      setShowMedSearch(true);
      setHideMed(false);
    } else {
      setShowMedSearch(false);
      setHideMed(true);
    }
  };

  const proAccSearch = (event) => {
    setAssEvent(event);
    if (event) {
      setSearchProAccResults(
        proAssLists.filter(
          (el) =>
            (el?.accessoryItemName)
              .toLowerCase()
              .includes(event.toLowerCase()) ||
            (el.name ? el.name.relatedBrand.name : "")
              .toLowerCase()
              .includes(event.toLowerCase()) ||
            el.code.toLowerCase().includes(event.toLowerCase()),
        ),
      );

      setShowProAccSearch(true);
      setHideProAcc(false);
    } else {
      setShowProAccSearch(false);
      setHideProAcc(true);
    }
  };

  const handleGeneralUnitChange = (Id) => {
    setShowMedicine(false);
    setShowProUnit(false);
    setShowProAss(false);
    setHideMed(false);
    setShowGeneral(true);
    setGeneralTable(true);

    if (Id) {
      setShowGeneral(true);
      setGeneralTable(false);
      setGeneralBranch(true);
      setShowMedicine(false);
      setShowProUnit(false);
      setShowProAss(false);
      setHideMed(false);
      setShowMedBranch(false);
    }
  };

  const handleMedUnitChange = (Id) => {
    if (medEvent) {
      window.location.reload();
    } else {
      setShowMedicine(true);
      setShowProUnit(false);
      setShowProAss(false);
      setHideMed(true);
      setShowGeneral(false);

      if (Id) {
        setShowMedicine(true);
        setShowProUnit(false);
        setShowProAss(false);
        setHideMed(false);
        setShowMedBranch(true);
        setShowGeneral(false);
      }
    }
  };

  const handleMBranchUpdateUnitCalculation = (event, medUnit, type) => {
    // console.log(medUnit.toUnit, "handle med unit");

    if (type === "currentQty") {
      let uQty = parseInt(event);

      let total =
        (event * medUnit.relatedMedicineItems.toUnit) /
        medUnit.relatedMedicineItems.fromUnit;

      // console.log(uQty * medUnit.toUnit)
      // setMbTotal(total)
      setMQty(event);
      // console.log(event, "m qty");
      const newData = medBranchLists.map((data) => {
        if (data._id === medUnit._id) {
          return { ...data, [type]: event, totalUnit: total };
        }
        return data;
      });
      // console.log(newData, "new data");
      setMedBranchLists(newData);
    } else if (type === "toUnit") {
      let total = event * medUnit.currentQty;
      // setMbTotal(total)
      // console.log(event * medUnit.currentQty);
      const newData = medBranchLists.map((data) => {
        if (data._id === medUnit._id) {
          return { ...data, [type]: event, totalUnit: total };
        }
        return data;
      });
      // console.log(newData);
      setMedBranchLists(newData);
    }
  };

  const handleMBranchUpdate = (medUnit) => {
    // console.log(medUnit.toUnit, 'med id')
    const data = {
      id: medUnit._id,
      relatedMedicineItems: medUnit.relatedMedicineItems._id,

      currentQty: medUnit.currentQty,
      fromUnit: medUnit.relatedMedicineItems.fromUnit,
      toUnit: medUnit.relatedMedicineItems.toUnit,
      totalUnit:
        (medUnit.currentQty * medUnit.relatedMedicineItems.toUnit) /
        medUnit.relatedMedicineItems.fromUnit,
      relatedBranch: branchID,
    };

    if (mPurchase > 0) {
      data.purchasePrice = parseInt(mPurchase);
    }
    if (mSell > 0) {
      data.sellingPrice = parseInt(mSell);
    }

    // alert(JSON.stringify(data))

    const config = {
      headers: { "Content-Type": "application/json" },
    };

    api
      .put("stock", data, config)

      .then(function (response) {
        // console.log(response.data);
        Swal.fire({
          title: "Successful!",
          text: "Successfully Updated",
          icon: "success",

          cancelButtonText: "Close",
        });
        //         // window.location.reload()

        //         // setUnitLists([...unitLists,response.data.list])

        //         // setUnitLists(
        //         //   unitLists.map(category => {
        //         //     if (category._id === response.data.list._id) {
        //         //       return response.data.list
        //         //     } else {
        //         //       return category
        //         //     }
        //         //   })
        //         // )
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      });
    // document.getElementById('desc').value = ''
    // document.getElementById('name').value = ''
    // document.getElementById('code').value = ''
  };

  const handleProBranchUpdateUnitCalculation = (event, proUnit, type) => {
    // console.log(proUnit.toUnit, "handle med unit");

    if (type === "currentQty") {
      let uQty = parseInt(event);

      let total =
        (event * proUnit.relatedProcedureItems.toUnit) /
        proUnit.relatedProcedureItems.fromUnit;

      // console.log(uQty * proUnit.toUnit)
      // setMbTotal(total)
      setMQty(event);
      // console.log(event, "m qty");
      const newData = proBranchLists.map((data) => {
        if (data._id === proUnit._id) {
          return { ...data, [type]: event, totalUnit: total };
        }
        return data;
      });
      // console.log(newData, "new data");
      setProBranchLists(newData);
    } else if (type === "toUnit") {
      let total = event * proUnit.currentQty;
      // setMbTotal(total)
      // console.log(event * proUnit.currentQty);
      const newData = proBranchLists.map((data) => {
        if (data._id === proUnit._id) {
          return { ...data, [type]: event, totalUnit: total };
        }
        return data;
      });
      // console.log(newData);
      setProBranchLists(newData);
    }
  };

  const handleProBranchUpdate = (proUnit) => {
    // console.log(proUnit, "med id");
    const data = {
      id: proUnit._id,
      relatedProcedureItems: proUnit.relatedProcedureItems._id,

      currentQty: proUnit.currentQty,
      fromUnit: proUnit.relatedProcedureItems.fromUnit,
      toUnit: proUnit.relatedProcedureItems.toUnit,
      totalUnit:
        (proUnit.currentQty * proUnit.relatedProcedureItems.toUnit) /
        proUnit.relatedProcedureItems.fromUnit,
      relatedBranch: branchID,
    };

    if (mPurchase > 0) {
      data.purchasePrice = parseInt(mPurchase);
    }
    if (mSell > 0) {
      data.sellingPrice = parseInt(mSell);
    }

    // alert(JSON.stringify(data))

    const config = {
      headers: { "Content-Type": "application/json" },
    };

    api
      .put("stock", data, config)

      .then(function (response) {
        // console.log(response.data);
        Swal.fire({
          title: "Successful!",
          text: "Successfully Updated",
          icon: "success",

          cancelButtonText: "Close",
        });
        //         // window.location.reload()

        //         // setUnitLists([...unitLists,response.data.list])

        //         // setUnitLists(
        //         //   unitLists.map(category => {
        //         //     if (category._id === response.data.list._id) {
        //         //       return response.data.list
        //         //     } else {
        //         //       return category
        //         //     }
        //         //   })
        //         // )
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      });
    // document.getElementById('desc').value = ''
    // document.getElementById('name').value = ''
    // document.getElementById('code').value = ''
  };

  const handleProAssBranchUpdateUnitCalculation = (event, proAssUnit, type) => {
    // console.log(proAssUnit.toUnit, "handle pro ass unit");

    if (type === "currentQty") {
      let uQty = parseInt(event);

      let total = (event * proAssUnit.toUnit) / proAssUnit.fromUnit;

      // console.log(
      //   (uQty * proAssUnit.relatedAccessoryItems.toUnit) /
      //     proAssUnit.relatedAccessoryItems.fromUnit,
      //   'ass total unit'
      // )
      // setMbTotal(total)
      setMQty(event);
      // console.log(event, "m qty");
      const newData = proAccBranchLists.map((data) => {
        if (data._id === proAssUnit._id) {
          return { ...data, [type]: event, totalUnit: total };
        }
        return data;
      });
      // console.log(newData, "new data");
      setProAccBranchLists(newData);
    } else if (type === "toUnit") {
      let total = event * proAssUnit.currentQty;
      // setMbTotal(total)
      // console.log(event * proAssUnit.currentQty);
      const newData = proAccBranchLists.map((data) => {
        if (data._id === proAssUnit._id) {
          return { ...data, [type]: event, totalUnit: total };
        }
        return data;
      });
      // console.log(newData);
      setProAccBranchLists(newData);
    }
  };

  const handleProAssBranchUpdate = (proAssUnit) => {
    // console.log(proAssUnit._id, "med id");
    // const data = {
    //   id: proAssUnit._id,
    //   relatedAccessoryItems: proAssUnit.relatedAccessoryItems._id,

    //   currentQty: proAssUnit.currentQty,
    //   fromUnit: proAssUnit.relatedAccessoryItems.fromUnit,
    //   toUnit: proAssUnit.relatedAccessoryItems.toUnit,
    //   totalUnit:
    //     (proAssUnit.currentQty * proAssUnit.relatedAccessoryItems.toUnit) /
    //     proAssUnit.relatedAccessoryItems.fromUnit,
    //   relatedBranch: branchID,
    // };
    const data = {
      id: proAssUnit._id,
      relatedAccessoryItems: proAssUnit.relatedAccessoryItems._id,

      currentQty: proAssUnit.currentQty,
      fromUnit: proAssUnit.fromUnit,
      toUnit: proAssUnit.toUnit,
      totalUnit:
        (proAssUnit.currentQty * proAssUnit.toUnit) / proAssUnit.fromUnit,
      relatedBranch: branchID,
    };

    if (mPurchase > 0) {
      data.purchasePrice = parseInt(mPurchase);
    }
    if (mSell > 0) {
      data.sellingPrice = parseInt(mSell);
    }

    // alert(JSON.stringify(data))

    const config = {
      headers: { "Content-Type": "application/json" },
    };

    api
      .put("stock", data, config)

      .then(function (response) {
        // console.log(response.data);
        Swal.fire({
          title: "Successful!",
          text: "Successfully Updated",
          icon: "success",

          cancelButtonText: "Close",
        });
        //         // window.location.reload()

        //         // setUnitLists([...unitLists,response.data.list])

        //         // setUnitLists(
        //         //   unitLists.map(category => {
        //         //     if (category._id === response.data.list._id) {
        //         //       return response.data.list
        //         //     } else {
        //         //       return category
        //         //     }
        //         //   })
        //         // )
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      });
    // document.getElementById('desc').value = ''
    // document.getElementById('name').value = ''
    // document.getElementById('code').value = ''
  };
  const handleGeneralBranchUpdateUnitCalculation = (event, genUnit, type) => {
    if (type === "currentQty") {
      let uQty = parseInt(event);

      let total =
        (uQty * genUnit.relatedGeneralItems.toUnit) /
        genUnit.relatedGeneralItems.fromUnit;

      // console.log(uQty * genUnit.toUnit)
      // setMbTotal(total)
      setMQty(event);
      // console.log(event, "m qty");
      const newData = generalBranchLists.map((data) => {
        if (data._id === genUnit._id) {
          return { ...data, [type]: event, totalUnit: total };
        }
        return data;
      });
      // console.log(newData, "new data");
      setGeneralBranchLists(newData);
    } else if (type === "toUnit") {
      let total = event * genUnit.currentQuantity;
      // setMbTotal(total)
      // console.log(event * genUnit.currentQuantity);
      const newData = generalBranchLists.map((data) => {
        if (data._id === genUnit._id) {
          return { ...data, [type]: event, totalUnit: total };
        }
        return data;
      });
      // console.log(newData);
      setGeneralBranchLists(newData);
    }
  };

  const handleGeneralBranchUpdate = (genUnit) => {
    // console.log(genUnit, "Gen Lsi");
    const data = {
      id: genUnit._id,
      relatedGeneralItems: genUnit.relatedGeneralItems._id,
      currentQty: genUnit.currentQty,
      fromUnit: genUnit.relatedGeneralItems.fromUnit,
      toUnit: genUnit.relatedGeneralItems.toUnit,
      totalUnit:
        (genUnit.currentQty * genUnit.relatedGeneralItems.toUnit) /
        genUnit.relatedGeneralItems.fromUnit,
      relatedBranch: branchID,
    };

    if (genPurchase > 0) {
      data.purchasePrice = parseInt(genPurchase);
    }
    if (genSell > 0) {
      data.sellingPrice = parseInt(genSell);
    }

    // alert(JSON.stringify(data))

    const config = {
      headers: { "Content-Type": "application/json" },
    };

    api
      .put("stock", data, config)

      .then(function (response) {
        // console.log(response.data);
        Swal.fire({
          title: "Successful!",
          text: "Successfully Updated",
          icon: "success",

          cancelButtonText: "Close",
        });
        //         // window.location.reload()

        //         // setUnitLists([...unitLists,response.data.list])

        //         // setUnitLists(
        //         //   unitLists.map(category => {
        //         //     if (category._id === response.data.list._id) {
        //         //       return response.data.list
        //         //     } else {
        //         //       return category
        //         //     }
        //         //   })
        //         // )
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      });
    // document.getElementById('desc').value = ''
    // document.getElementById('name').value = ''
    // document.getElementById('code').value = ''
  };

  const handleProUnitChange = (Id) => {
    if (proEvent) {
      window.location.reload();
    } else {
      setShowMedicine(false);
      setShowProUnit(true);
      setShowProAss(false);
      setShowGeneral(false);

      setHidePro(true);

      if (Id) {
        setShowMedicine(false);
        setShowProUnit(true);
        setShowProAss(false);
        setShowGeneral(false);

        setShowProBranch(true);
        setHidePro(false);
      }
    }
  };

  const handleProAssUnitChange = (Id) => {
    if (assEvent) {
      window.location.reload();
    } else {
      setShowMedicine(false);
      setShowProUnit(false);
      setShowProAss(true);
      setHideProAcc(true);
      setShowGeneral(false);

      if (Id) {
        setShowMedicine(false);
        setShowProUnit(false);
        setShowProAss(true);
        setHideProAcc(false);
        setShowProAccBranch(true);
        setShowGeneral(false);
      }
    }
  };

  //For Hide and Show related branch data
  const handleBranch = (event) => {
    if (event == "HO") {
      setHO(event);
      window.location.reload();
      // console.log()
    }
    setBranchID(event);

    const getStockLists = async () => {
      try {
        const res = await api.get("stocks/branch", {
          params: { relatedBranch: event },
        });
        // console.log(res.data.data, "res");
        if (event === "649559535fc22f0e7f0884fe") {
          setMedBranchLists(res.data.data.MedicineItems);
        } else {
          setMedBranchLists(res.data.data.MedicineItems);
        }

        if (event === "649559535fc22f0e7f0884fe") {
          setProBranchLists(res.data.data.ProcedureItems);
        } else {
          setProBranchLists(res.data.data.ProcedureItems);
        }

        if (event === "649559535fc22f0e7f0884fe") {
          setProAccBranchLists(res.data.data.AccessoryItems);
        } else {
          setProAccBranchLists(res.data.data.AccessoryItems);
        }
        if (event === "649559535fc22f0e7f0884fe") {
          setGeneralBranchLists(res.data.data.GeneralItems);
          // console.log(res.data.data.GeneralItems, "gen branch");
        } else {
          setGeneralBranchLists(res.data.data.GeneralItems);
        }
      } catch (err) {
        alert(err.message);
      }
    };

    getStockLists();
  };
  return (
    <>

      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-12">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item active ">
                    Stock Count & Price
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row d-flex justify-content-between ">
              <div className="col-md-6">
                {/* <h4>Medicine Item List</h4> */}
              </div>
              <div className="offset-1 col-md-4 ml-5">
                <div
                  className="input-group row ml-5"
                  style={{ marginBottom: "20px" }}
                >
                  {/* <div className="col-md-6 mt-1">
                      <button
                        type="button"
                        className="btn  btn-primary ml-4"
                        style={{ borderRadius: "7px" }}
                        onClick={showDialog}>
                        Add Item
                      </button>
                    </div> */}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                      <div className="col-md-8">
                        <div className="row">
                          <div className="col-3">
                            <Button
                              style={ButtonStyle}
                              onClick={() => handleMedUnitChange(branchID)}
                            >
                              Medicine Items
                            </Button>
                          </div>
                          <div className="col-3">
                            <Button
                              style={ButtonStyle}
                              onClick={() => handleProUnitChange(branchID)}
                            >
                              Procedure Items
                            </Button>
                          </div>
                          <div className="col-3">
                            <Button
                              style={ButtonStyle}
                              onClick={() => handleProAssUnitChange(branchID)}
                            >
                              Procedure Accessories
                            </Button>
                          </div>
                          <div className="col-3">
                            <Button
                              style={ButtonStyle}
                              onClick={() =>
                                handleGeneralUnitChange(branchID)
                              }
                            >
                              General Items
                            </Button>
                          </div>
                        </div>
                      </div>
                      <div className="offset-1 col-md-3 mt-1">
                        <div className="form-group">
                          <select
                            name="currency"
                            id=""
                            className="form-control mt-1"
                            onchange="convert(this.value)"
                            // placeholder='Filter By Branches'
                            onChange={(e) => {
                              handleBranch(e.target.value);
                              setHO(e.target.value);
                            }}
                          >
                            <option hidden>Filter By Branches</option>
                            <option value="HO">HO</option>

                            {branchesLists.map((option) => (
                              <option value={option._id}>
                                {option.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card-body">
                    {/* Export data in Excel */}
                    {/* For Procedure Medicine Items */}
                    <ExcelExport data={proHOCheckList} ref={_export1}>
                      <ExcelExportColumn
                        field=""
                        title="No"
                        locked={true}
                        width={30}
                      />
                      <ExcelExportColumn
                        field="code"
                        title="Code"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={200}
                      />
                      <ExcelExportColumn
                        field="name.relatedBrand.name"
                        title="Brand"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={250}
                      />

                      <ExcelExportColumn
                        field="procedureItemName"
                        title="Procedure Item Name"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={250}
                      />
                      <ExcelExportColumn
                        field="currentQuantity"
                        title="Qty"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={250}
                      />

                      <ExcelExportColumn
                        field="fromUnit"
                        title="From Unit"
                        width={150}
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                      />
                      <ExcelExportColumn
                        field="toUnit"
                        title="To Unit"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="totalUnit"
                        title="Total Unit"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="sellingPrice"
                        title="Selling Price"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="purchasePrice"
                        title="Purchase Price"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="unit"
                        title="Unit"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="description"
                        title="Desc"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />

                      <ExcelExportColumn
                        field="actualStock"
                        title="Actual Stock"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="different"
                        title="Different"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="checkby"
                        title="Checked By"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                    </ExcelExport>
                    {/* End        */}

                    {/* For Medicine Items */}
                    <ExcelExport data={medHOCheckList} ref={_export2}>
                      <ExcelExportColumn
                        field=""
                        title="No"
                        locked={true}
                        width={30}
                      />
                      <ExcelExportColumn
                        field="code"
                        title="Code"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={200}
                      />
                      <ExcelExportColumn
                        field="name.relatedBrand.name"
                        title="Brand"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={250}
                      />

                      <ExcelExportColumn
                        field="medicineItemName"
                        title="Medicine Item Name"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={250}
                      />
                      <ExcelExportColumn
                        field="currentQuantity"
                        title="Qty"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={250}
                      />
                      <ExcelExportColumn
                        field="fromUnit"
                        title="From Unit"
                        width={150}
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                      />
                      <ExcelExportColumn
                        field="toUnit"
                        title="To Unit"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="totalUnit"
                        title="Total Unit"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />

                      <ExcelExportColumn
                        field="sellingPrice"
                        title="Selling Price"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="purchasePrice"
                        title="Purchase Price"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="unit"
                        title="Unit"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="description"
                        title="Desc"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />

                      <ExcelExportColumn
                        field="actualStock"
                        title="Actual Stock"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />

                      <ExcelExportColumn
                        field="different"
                        title="Different"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="checkby"
                        title="Checked By"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                    </ExcelExport>
                    {/* End     */}

                    {/* For Procedure Accessory FilterItems */}
                    <ExcelExport data={proAssHOCheckList} ref={_export3}>
                      <ExcelExportColumn
                        field=""
                        title="No"
                        locked={true}
                        width={30}
                      />
                      <ExcelExportColumn
                        field="code"
                        title="Code"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={200}
                      />
                      <ExcelExportColumn
                        field="name.relatedBrand.name"
                        title="Brand"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={250}
                      />
                      <ExcelExportColumn
                        field="accessoryItemName"
                        title="Procedure Accessory Item Name"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={250}
                      />
                      <ExcelExportColumn
                        field="currentQuantity"
                        title="Qty"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={250}
                      />
                      <ExcelExportColumn
                        field="fromUnit"
                        title="From Unit"
                        width={150}
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                      />
                      <ExcelExportColumn
                        field="toUnit"
                        title="To Unit"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />

                      <ExcelExportColumn
                        field="totalUnit"
                        title="Total Unit"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="sellingPrice"
                        title="Selling Price"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="purchasePrice"
                        title="Purchase Price"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="unit"
                        title="Unit"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="description"
                        title="Desc"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="actualStock"
                        title="Actual Stock"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="different"
                        title="Different"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="checkby"
                        title="Checked By"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                    </ExcelExport>

                    {/* End */}
                    {/* For General FilterItems */}
                    <ExcelExport data={generalHOCheckList} ref={_export4}>
                      <ExcelExportColumn
                        field=""
                        title="No"
                        locked={true}
                        width={30}
                      />
                      <ExcelExportColumn
                        field="code"
                        title="Code"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={200}
                      />
                      <ExcelExportColumn
                        field="name.relatedBrand.name"
                        title="Brand"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={250}
                      />
                      <ExcelExportColumn
                        field="generalItemName"
                        title="General Item Name"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={250}
                      />
                      <ExcelExportColumn
                        field="currentQuantity"
                        title="Qty"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={250}
                      />
                      <ExcelExportColumn
                        field="fromUnit"
                        title="From Unit"
                        width={150}
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                      />
                      <ExcelExportColumn
                        field="toUnit"
                        title="To Unit"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />

                      <ExcelExportColumn
                        field="totalUnit"
                        title="Total Unit"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="sellingPrice"
                        title="Selling Price"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="purchasePrice"
                        title="Purchase Price"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="unit"
                        title="Unit"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="description"
                        title="Desc"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="actualStock"
                        title="Actual Stock"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="different"
                        title="Different"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="checkby"
                        title="Checked By"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                    </ExcelExport>

                    {/* End */}

                    {/* Export Data in Excel end */}
                    <div className="row">
                      <div className="col-md-12">
                        {showProUnit && (
                          <div>
                            {showProBranch ? (
                              ""
                            ) : (
                              <>
                                {proHOCount !== 0 && (
                                  <div>
                                    <div
                                      className="bg-warning"
                                      style={{
                                        padding: "15px",
                                        borderRadius: "5px",
                                        fontSize: "18px",
                                      }}
                                    >
                                      You have Expired Procedure Items :
                                      <b>{proHOCount}</b>. &nbsp;
                                      <Link
                                        to="/expDateList"
                                        className="text-decoration-underline text-white"
                                      >
                                        Check
                                      </Link>{" "}
                                    </div>
                                  </div>
                                )}

                                <div className="row mb-3">
                                  <div className="col-md-2 mt-1">
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-dark"
                                      onClick={excelExport1}
                                    >
                                      <FaFileExport />
                                      &nbsp; Export
                                    </button>
                                    &nbsp;
                                  </div>
                                  <div className="col-md-4 mt-1">
                                    <b className="btn btn-sm btn-dark">
                                      Total Inventory Value :{" "}
                                      {proTotal.toFixed(2)} MMK
                                    </b>
                                  </div>

                                  <div className="offset-2 col-md-3 mr-2">
                                    <input
                                      type="search"
                                      className="form-control rounded "
                                      style={{ borderRadius: "17px" }}
                                      onChange={(e) =>
                                        proSearch(e.target.value)
                                      }
                                      id="search_code"
                                      placeholder="Search Items"
                                    />
                                  </div>
                                </div>
                              </>
                            )}

                            <div className="table-responsive">
                              <table className="table table-hover">
                                <div style={scroll}>
                                  <thead
                                    className="sticky-top bg-light"
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    <tr>
                                      <th style={{ fontWeight: "400px" }}>
                                        #
                                      </th>
                                      <th style={{ fontWeight: "400px" }}>
                                        Code
                                      </th>
                                      <th style={{ fontWeight: "400px" }}>
                                        Brand
                                      </th>
                                      <th style={{ fontWeight: "400px" }}>
                                        Name
                                      </th>
                                      <th style={{ fontWeight: "400px" }}>
                                        Qty
                                      </th>
                                      <th style={{ fontWeight: "400px" }}>
                                        From Unit
                                      </th>
                                      <th style={{ fontWeight: "400px" }}>
                                        To Unit
                                      </th>
                                      <th style={{ fontWeight: "400px" }}>
                                        Total Unit
                                      </th>

                                      <th style={{ fontWeight: "400px" }}>
                                        TCL Sell
                                      </th>

                                      <th style={{ fontWeight: "400px" }}>
                                        Selling( MMK )
                                      </th>
                                      <th style={{ fontWeight: "400px" }}>
                                        Purchase( MMK )
                                      </th>
                                      <th style={{ fontWeight: "400px" }}>
                                        Unit
                                      </th>
                                      <th>Desc</th>
                                      <th
                                        className="text-center"
                                        style={{ fontWeight: "400px" }}
                                      >
                                        Action
                                      </th>

                                      {(hidePro || showProSearch) && (
                                        <th className="flex justify-content-between">
                                          Select All &nbsp;
                                          <input
                                            type="checkbox"
                                            onClick={(e) =>
                                              handleProSelectAll(
                                                e,
                                                proUnitLists,
                                                "checkBox",
                                              )
                                            }
                                          />
                                        </th>
                                      )}
                                    </tr>
                                  </thead>

                                  <tbody>
                                    {showProBranch &&
                                      proBranchLists.map((proUnit, i) => (
                                        <tr>
                                          <td>{++i}</td>
                                          <td>
                                            {proUnit.relatedProcedureItems
                                              ? proUnit.relatedProcedureItems
                                                .code
                                              : ""}
                                          </td>
                                          <td>
                                            {proUnit.relatedProcedureItems
                                              ? proUnit.relatedProcedureItems
                                                .name.relatedBrand.name
                                              : ""}
                                          </td>
                                          <td>
                                            {proUnit.relatedProcedureItems
                                              ? proUnit.relatedProcedureItems
                                                .procedureItemName
                                              : ""}
                                          </td>

                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => {
                                                e.preventDefault();
                                                e.target.blur();
                                              }}
                                              defaultValue={Number(
                                                proUnit.currentQty,
                                              ).toFixed(2)}
                                              onChange={(e) =>
                                                handleProBranchUpdateUnitCalculation(
                                                  e.target.value,
                                                  proUnit,
                                                  "currentQty",
                                                )
                                              }
                                              className="p-2 rounded-lg"
                                            />
                                          </td>
                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => {
                                                e.preventDefault();
                                                e.target.blur();
                                              }}
                                              defaultValue={
                                                proUnit.relatedProcedureItems
                                                  ? proUnit
                                                    .relatedProcedureItems
                                                    .fromUnit
                                                  : ""
                                              }
                                              //  onChange={(e)=>setFrom(e.target.value)}
                                              disabled
                                              className="p-2 rounded-lg"
                                            />
                                          </td>
                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => {
                                                e.preventDefault();
                                                e.target.blur();
                                              }}
                                              defaultValue={
                                                proUnit.relatedProcedureItems
                                                  ? proUnit
                                                    .relatedProcedureItems
                                                    .toUnit
                                                  : ""
                                              }
                                              onChange={(e) =>
                                                handleProBranchUpdateUnitCalculation(
                                                  e.target.value,
                                                  proUnit,
                                                  "toUnit",
                                                )
                                              }
                                              className="p-2 rounded-lg"
                                              disabled
                                            />
                                          </td>
                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => {
                                                e.preventDefault();
                                                e.target.blur();
                                              }}
                                              value={
                                                Number(
                                                  proUnit.totalUnit,
                                                ).toFixed(2) ||
                                                proUnit.currentQty *
                                                proUnit
                                                  .relatedProcedureItems
                                                  .toUnit
                                              }
                                              className="p-2 rounded-lg"
                                              disabled
                                            //onChange={(e)=>setPMTotal(e.target.value)}
                                            />
                                          </td>
                                          {proUnit?.TCLSellingPrice ? (
                                            <td>
                                              <input
                                                type="number"
                                                onWheel={(e) => {
                                                  e.preventDefault();
                                                  e.target.blur();
                                                }}
                                                defaultValue={
                                                  proUnit?.TCLSellingPrice
                                                }
                                                onChange={(e) =>
                                                  setMSell(e.target.value)
                                                }
                                                className="p-2 rounded-lg"
                                                disabled
                                              />
                                            </td>
                                          ) : (
                                            <td>
                                              <input
                                                type="text"
                                                value={"Not Set"}
                                                onChange={(e) =>
                                                  setMSell(e.target.value)
                                                }
                                                className="p-2 rounded-lg"
                                                disabled
                                              />
                                            </td>
                                          )}

                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => {
                                                e.preventDefault();
                                                e.target.blur();
                                              }}
                                              value={
                                                proUnit.relatedProcedureItems
                                                  ?.sellingPrice
                                                  ? proUnit
                                                    .relatedProcedureItems
                                                    .sellingPrice
                                                  : ""
                                              }
                                              onChange={(e) =>
                                                setPMSell(e.target.value)
                                              }
                                              className="p-2 rounded-lg"
                                            />
                                          </td>
                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => {
                                                e.preventDefault();
                                                e.target.blur();
                                              }}
                                              value={
                                                proUnit.relatedProcedureItems
                                                  ? proUnit
                                                    .relatedProcedureItems
                                                    .purchasePrice
                                                  : ""
                                              }
                                              onChange={(e) =>
                                                setPMPurchase(e.target.value)
                                              }
                                              className="p-2 rounded-lg"
                                            />
                                          </td>
                                          <td>
                                            {proUnit.relatedProcedureItems
                                              ? proUnit.relatedProcedureItems
                                                .unit
                                              : ""}
                                          </td>
                                          <td>
                                            {proUnit.relatedProcedureItems
                                              ? proUnit.relatedProcedureItems
                                                .description
                                              : ""}
                                          </td>
                                          <td className="text-center">
                                            {/* <button
                                                onClick={() =>
                                                  submitPro(proUnit._id)
                                                }
                                                className='btn btn-sm btn-danger mt-3'
                                                data-toggle='modal'
                                                data-target='#edit_stock{{$list->id}}'
                                              >
                                                <FaTrashAlt />
                                              </button> */}
                                            &nbsp;
                                            <button
                                              onClick={(e) =>
                                                handleProBranchUpdate(proUnit)
                                              }
                                              className="btn btn-sm btn-dark mt-3"
                                            // data-toggle='modal'
                                            // data-target='#edit_stock{{$list->id}}'
                                            >
                                              <FaAngleDoubleRight />
                                            </button>
                                          </td>
                                        </tr>
                                      ))}

                                    {hidePro &&
                                      proUnitLists.map((proUnit, i) => (
                                        <tr>
                                          <td>{++i}</td>
                                          <td>{proUnit.code}</td>
                                          <td>
                                            {proUnit.name
                                              ? proUnit.name.relatedBrand.name
                                              : ""}
                                          </td>
                                          <td>{proUnit.procedureItemName}</td>
                                          <td>
                                            {proUnit.reOrderQuantity >=
                                              proUnit.currentQuantity ? (
                                              <input
                                                type="number"
                                                onWheel={(e) => {
                                                  e.preventDefault();
                                                  e.target.blur();
                                                }}
                                                defaultValue={Number(
                                                  proUnit.currentQuantity,
                                                ).toFixed(2)}
                                                onChange={(e) =>
                                                  handleUpdateUnitCalculation(
                                                    e.target.value,
                                                    proUnit,
                                                    "currentQuantity",
                                                  )
                                                }
                                                className="p-2 rounded-lg"
                                                style={{
                                                  border: "1px solid red",
                                                }}
                                              />
                                            ) : (
                                              <input
                                                type="number"
                                                onWheel={(e) => {
                                                  e.preventDefault();
                                                  e.target.blur();
                                                }}
                                                defaultValue={Number(
                                                  proUnit.currentQuantity,
                                                ).toFixed(2)}
                                                onChange={(e) =>
                                                  handleUpdateUnitCalculation(
                                                    e.target.value,
                                                    proUnit,
                                                    "currentQuantity",
                                                  )
                                                }
                                                className="p-2 rounded-lg"
                                              />
                                            )}
                                          </td>
                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => {
                                                e.preventDefault();
                                                e.target.blur();
                                              }}
                                              defaultValue={proUnit.fromUnit}
                                              //  onChange={(e)=>setFrom(e.target.value)}
                                              disabled
                                              className="p-2 rounded-lg"
                                            />
                                          </td>
                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => {
                                                e.preventDefault();
                                                e.target.blur();
                                              }}
                                              value={proUnit.toUnit}
                                              onFocus={() => {
                                                prevPMToUnitRef.current =
                                                  proUnit.toUnit;
                                              }}
                                              onChange={(e) =>
                                                handleUpdateUnitCalculation(
                                                  e.target.value,
                                                  proUnit,
                                                  "toUnit",
                                                )
                                              }
                                              className="p-2 rounded-lg"
                                            />
                                          </td>
                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => {
                                                e.preventDefault();
                                                e.target.blur();
                                              }}
                                              value={Number(
                                                proUnit.totalUnit,
                                              ).toFixed(2)}
                                              className="p-2 rounded-lg"
                                              disabled
                                            //onChange={(e)=>setPMTotal(e.target.value)}
                                            />
                                          </td>
                                          {proUnit?.TCLSellingPrice ? (
                                            <td>
                                              <input
                                                type="number"
                                                onWheel={(e) => {
                                                  e.preventDefault();
                                                  e.target.blur();
                                                }}
                                                defaultValue={
                                                  proUnit?.TCLSellingPrice
                                                }
                                                className="p-2 rounded-lg"
                                                disabled
                                              />
                                            </td>
                                          ) : (
                                            <td>
                                              <input
                                                type="text"
                                                defaultValue={"Not Set"}
                                                className="p-2 rounded-lg"
                                                disabled
                                              />
                                            </td>
                                          )}

                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => {
                                                e.preventDefault();
                                                e.target.blur();
                                              }}
                                              defaultValue={
                                                proUnit.sellingPrice
                                              }
                                              onChange={(e) =>
                                                setPMSell(e.target.value)
                                              }
                                              className="p-2 rounded-lg"
                                            />
                                          </td>
                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => {
                                                e.preventDefault();
                                                e.target.blur();
                                              }}
                                              defaultValue={
                                                proUnit.purchasePrice
                                              }
                                              onChange={(e) =>
                                                setPMPurchase(e.target.value)
                                              }
                                              className="p-2 rounded-lg"
                                            />
                                          </td>
                                          <td>
                                            {proUnit.unit ? proUnit.unit : ""}
                                          </td>
                                          <td>{proUnit.description}</td>
                                          <td className="text-center">
                                            <button
                                              onClick={(e) =>
                                                handlePMUpdate(proUnit)
                                              }
                                              className="btn btn-sm btn-dark mt-3"
                                            // data-toggle='modal'
                                            // data-target='#edit_stock{{$list->id}}'
                                            >
                                              <FaAngleDoubleRight />
                                            </button>
                                          </td>

                                          <td>
                                            <input
                                              type="checkbox"
                                              key={proUnit}
                                              // value={isChecked}
                                              //   checked={medUnit.find(
                                              //     item =>
                                              //       item._id === medUnit._id
                                              //   )}
                                              // />
                                              onClick={(e) =>
                                                handleProCheck(
                                                  e,
                                                  proUnit,
                                                  "checkBox",
                                                )
                                              }
                                            />
                                          </td>
                                        </tr>
                                      ))}

                                    {showProSearch &&
                                      searchProResults.map((proUnit, i) => (
                                        <tr>
                                          <td>{++i}</td>
                                          <td>{proUnit.code}</td>
                                          <td>
                                            {proUnit.name
                                              ? proUnit.name.relatedBrand.name
                                              : ""}
                                          </td>
                                          <td>{proUnit.procedureItemName}</td>
                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => {
                                                e.preventDefault();
                                                e.target.blur();
                                              }}
                                              value={Number(
                                                proUnit.currentQuantity,
                                              ).toFixed(2)}
                                              onChange={(e) =>
                                                handleUpdateSearchUnitCalculation(
                                                  e.target.value,
                                                  proUnit,
                                                  "currentQuantity",
                                                )
                                              }
                                              className="form-control"
                                            />
                                          </td>
                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => {
                                                e.preventDefault();
                                                e.target.blur();
                                              }}
                                              defaultValue={proUnit.fromUnit}
                                              //  onChange={(e)=>setFrom(e.target.value)}
                                              disabled
                                              className="form-control"
                                            />
                                          </td>
                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => {
                                                e.preventDefault();
                                                e.target.blur();
                                              }}
                                              value={proUnit.toUnit}
                                              onFocus={() => {
                                                prevPMToUnitRef.current =
                                                  proUnit.toUnit;
                                              }}
                                              onChange={(e) =>
                                                handleUpdateSearchUnitCalculation(
                                                  e.target.value,
                                                  proUnit,
                                                  "toUnit",
                                                )
                                              }
                                              className="form-control"
                                            />
                                          </td>
                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => {
                                                e.preventDefault();
                                                e.target.blur();
                                              }}
                                              value={Number(
                                                proUnit.totalUnit,
                                              ).toFixed(2)}
                                              className="form-control"
                                              disabled
                                            //onChange={(e)=>setPMTotal(e.target.value)}
                                            />
                                          </td>
                                          {proUnit?.TCLSellingPrice ? (
                                            <td>
                                              <input
                                                type="number"
                                                onWheel={(e) => {
                                                  e.preventDefault();
                                                  e.target.blur();
                                                }}
                                                value={
                                                  proUnit?.TCLSellingPrice
                                                }
                                                className="form-control"
                                                disabled
                                              />
                                            </td>
                                          ) : (
                                            <td>
                                              <input
                                                type="text"
                                                defaultValue={"Not Set"}
                                                className="form-control"
                                                disabled
                                              />
                                            </td>
                                          )}

                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => {
                                                e.preventDefault();
                                                e.target.blur();
                                              }}
                                              value={proUnit.sellingPrice}
                                              onChange={(e) =>
                                                setPMSell(e.target.value)
                                              }
                                              className="form-control"
                                            />
                                          </td>
                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => {
                                                e.preventDefault();
                                                e.target.blur();
                                              }}
                                              value={proUnit.purchasePrice}
                                              disabled
                                              onChange={(e) =>
                                                setPMPurchase(e.target.value)
                                              }
                                              className="form-control"
                                            />
                                          </td>
                                          <td>
                                            {proUnit.unit ? proUnit.unit : ""}
                                          </td>
                                          <td>{proUnit.description}</td>
                                          <td className="text-center">
                                            <button
                                              onClick={(e) =>
                                                handlePMUpdate(proUnit)
                                              }
                                              className="btn btn-sm btn-dark mt-3"
                                            // data-toggle='modal'
                                            // data-target='#edit_stock{{$list->id}}'
                                            >
                                              <FaAngleDoubleRight />
                                            </button>
                                          </td>

                                          <td>
                                            <input
                                              type="checkbox"
                                              key={proUnit}
                                              // value={isChecked}
                                              //   checked={medUnit.find(
                                              //     item =>
                                              //       item._id === medUnit._id
                                              //   )}
                                              // />
                                              onClick={(e) =>
                                                handleProCheck(
                                                  e,
                                                  proUnit,
                                                  "checkBox",
                                                )
                                              }
                                            />
                                          </td>
                                        </tr>
                                      ))}
                                  </tbody>
                                </div>
                              </table>
                            </div>
                          </div>
                        )}

                        {showMedicine && (
                          <div>
                            {showMedBranch ? (
                              ""
                            ) : (
                              <>
                                {medHOCount !== 0 && (
                                  <div>
                                    <div
                                      className="bg-warning "
                                      style={{
                                        padding: "15px",
                                        borderRadius: "5px",
                                        fontSize: "18px",
                                      }}
                                    >
                                      You have Expired Medicine Items :
                                      <b>{medHOCount}</b>. &nbsp;
                                      <Link
                                        to="/expDateList"
                                        className="text-decoration-underline text-white"
                                      >
                                        Check
                                      </Link>{" "}
                                    </div>
                                  </div>
                                )}

                                <div className="row mb-3">
                                  <div className="col-1">
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-dark"
                                      onClick={excelExport2}
                                    >
                                      <FaFileExport />
                                      &nbsp; Export
                                    </button>
                                    &nbsp;
                                    {/* <button
                                          type='button'
                                          className='btn btn-sm btn-dark'
                                          onClick={() => setOpen(true)}
                                        >
                                          Data Entry
                                        </button> */}
                                  </div>
                                  <div className="col-md-3 mt-1">
                                    <b className="btn btn-sm btn-dark">
                                      Total Inventory Value :{" "}
                                      {medTotal ? medTotal.toFixed(2) : ""}{" "}
                                      MMK
                                    </b>
                                  </div>
                                  <div className="col-6">
                                    {/* <div className='row'>
                                            <div className='form-group col-4'>
                                            
                                              <input
                                                type='date'
                                                name='from'
                                                id='from'
                                                onChange={(e) =>
                                                  setFrom(e.target.value)
                                                }
                                                className='form-control'
                                              />
                                            </div>
                                            <div className='form-group col-4'>
                                           
                                              <input
                                                type='date'
                                                name='to'
                                                id='to'
                                                placeholder='To'
                                                onChange={(e) =>
                                                  setTo(e.target.value)
                                                }
                                                className='form-control'
                                              />
                                            </div>
                                            <div className='form-group col-md-2'>
                                              <button
                                                className='btn btn-md btn-primary'
                                                style={{ marginTop: "5px" }}
                                                onClick={handleFilterDate}
                                              >
                                                Search
                                              </button>
                                              &nbsp;
                                              <button
                                                className='btn btn-md btn-success'
                                                style={{ marginTop: "5px" }}
                                                // onClick={handleFilterDate}
                                              >
                                                <FaCalculator />
                                              </button>
                                            </div>
                                          </div> */}
                                  </div>
                                  <div className=" col-2">
                                    <input
                                      type="search"
                                      className="form-control rounded "
                                      style={{ borderRadius: "17px" }}
                                      onChange={(e) =>
                                        medSearch(e.target.value)
                                      }
                                      id="search_code"
                                      placeholder="Search Items"
                                    />

                                    {/* <div className='col-md-4 mt-2'>
                                          <button
                                            type='button'
                                            className='btn btn-sm btn-dark'
                                            onClick={search}
                                          >
                                            Search
                                          </button>
                                        </div> */}
                                  </div>
                                </div>
                              </>
                            )}
                            <div className="table-responsive">
                              <table className="table table-hover">
                                <div style={scroll}>
                                  {medUnitLists[0] ? (
                                    <>
                                      <thead
                                        className="sticky-top bg-light"
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        <tr>
                                          <th
                                            style={{
                                              fontWeight: "400px",
                                            }}
                                          >
                                            #
                                          </th>
                                          <th
                                            style={{
                                              fontWeight: "400px",
                                            }}
                                          >
                                            Code
                                          </th>
                                          <th>Brand</th>
                                          <th
                                            style={{
                                              fontWeight: "400px",
                                            }}
                                          >
                                            Name
                                          </th>
                                          <th
                                            style={{
                                              fontWeight: "400px",
                                            }}
                                          >
                                            Qty
                                          </th>
                                          <th
                                            style={{
                                              fontWeight: "400px",
                                            }}
                                          >
                                            From Unit
                                          </th>
                                          <th
                                            style={{
                                              fontWeight: "400px",
                                            }}
                                          >
                                            To Unit
                                          </th>
                                          <th
                                            style={{
                                              fontWeight: "400px",
                                            }}
                                          >
                                            Total Unit
                                          </th>

                                          <th
                                            style={{
                                              fontWeight: "400px",
                                            }}
                                          >
                                            TCL Sell
                                          </th>

                                          <th
                                            style={{
                                              fontWeight: "400px",
                                            }}
                                          >
                                            Selling( MMK )
                                          </th>

                                          <th
                                            style={{
                                              fontWeight: "400px",
                                            }}
                                          >
                                            Purchase( MMK )
                                          </th>
                                          <th
                                            style={{
                                              fontWeight: "400px",
                                            }}
                                          >
                                            Unit
                                          </th>
                                          <th
                                            style={{
                                              fontWeight: "400px",
                                            }}
                                          >
                                            Opening
                                          </th>
                                          <th
                                            style={{
                                              fontWeight: "400px",
                                            }}
                                          >
                                            Purchase
                                          </th>
                                          <th
                                            style={{
                                              fontWeight: "400px",
                                            }}
                                          >
                                            Closing
                                          </th>
                                          <th
                                            style={{
                                              fontWeight: "400px",
                                            }}
                                          >
                                            Transfer
                                          </th>
                                          <th>Desc</th>

                                          <th
                                            className="text-center"
                                            style={{
                                              fontWeight: "400px",
                                            }}
                                          >
                                            Action
                                          </th>
                                          {(hideMed || showMedSearch) && (
                                            <th>
                                              Select All &nbsp;
                                              <input
                                                type="checkbox"
                                                onClick={(e) =>
                                                  handleMedSelectAll(
                                                    e,
                                                    medUnitLists,
                                                    "checkBox",
                                                  )
                                                }
                                              />
                                            </th>
                                          )}
                                        </tr>
                                      </thead>
                                      <tbody id="table_body">
                                        {showMedSearch &&
                                          searchMedResults.map(
                                            (medUnit, i) => (
                                              <tr>
                                                <td>{++i}</td>
                                                <td>{medUnit.code}</td>
                                                <td>
                                                  {medUnit.name
                                                    ? medUnit.name
                                                      .relatedBrand.name
                                                    : ""}
                                                </td>
                                                <td>
                                                  {medUnit.medicineItemName}
                                                </td>
                                                <td>
                                                  <input
                                                    type="number"
                                                    onWheel={(e) => {
                                                      e.preventDefault();
                                                      e.target.blur();
                                                    }}
                                                    value={Number(
                                                      medUnit?.currentQuantity,
                                                    ).toFixed(2)}
                                                    onChange={(e) =>
                                                      handleMSearchUpdateUnitCalculation(
                                                        e.target.value,
                                                        medUnit,
                                                        "currentQuantity",
                                                      )
                                                    }
                                                    className="form-control"
                                                  />
                                                </td>
                                                <td>
                                                  <input
                                                    type="number"
                                                    onWheel={(e) => {
                                                      e.preventDefault();
                                                      e.target.blur();
                                                    }}
                                                    defaultValue={Number(
                                                      medUnit?.fromUnit,
                                                    ).toFixed(2)}
                                                    disabled
                                                    className="form-control"
                                                  />
                                                </td>
                                                <td>
                                                  <input
                                                    type="number"
                                                    onWheel={(e) => {
                                                      e.preventDefault();
                                                      e.target.blur();
                                                    }}
                                                    value={Number(
                                                      medUnit.toUnit,
                                                    ).toFixed(2)}
                                                    onFocus={() => {
                                                      prevToUnitRef.current =
                                                        medUnit.toUnit;
                                                    }}
                                                    onChange={(e) =>
                                                      handleMSearchUpdateUnitCalculation(
                                                        e.target.value,
                                                        medUnit,
                                                        "toUnit",
                                                      )
                                                    }
                                                    className="form-control"
                                                  />
                                                </td>
                                                <td>
                                                  <input
                                                    type="number"
                                                    onWheel={(e) => {
                                                      e.preventDefault();
                                                      e.target.blur();
                                                    }}
                                                    value={Number(
                                                      medUnit.currentQuantity *
                                                      medUnit.toUnit,
                                                    ).toFixed(2)}
                                                    disabled
                                                    className="form-control"
                                                  />
                                                </td>
                                                {medUnit?.TCLSellingPrice ? (
                                                  <td>
                                                    <input
                                                      type="number"
                                                      onWheel={(e) => {
                                                        e.preventDefault();
                                                        e.target.blur();
                                                      }}
                                                      value={Number(
                                                        medUnit?.TCLSellingPrice,
                                                      ).toFixed(2)}
                                                      className="form-control"
                                                      disabled
                                                    />
                                                  </td>
                                                ) : (
                                                  <td>
                                                    <input
                                                      type="text"
                                                      defaultValue={"Not Set"}
                                                      className="form-control"
                                                      disabled
                                                    />
                                                  </td>
                                                )}

                                                <td>
                                                  <input
                                                    type="number"
                                                    onWheel={(e) => {
                                                      e.preventDefault();
                                                      e.target.blur();
                                                    }}
                                                    value={Number(
                                                      medUnit.sellingPrice,
                                                    ).toFixed(2)}
                                                    onChange={(e) =>
                                                      setMSell(e.target.value)
                                                    }
                                                    className="form-control"
                                                  />
                                                </td>
                                                <td>
                                                  <input
                                                    type="number"
                                                    onWheel={(e) => {
                                                      e.preventDefault();
                                                      e.target.blur();
                                                    }}
                                                    value={Number(
                                                      medUnit.purchasePrice,
                                                    ).toFixed(2)}
                                                    disabled
                                                    onChange={(e) =>
                                                      setMPurchase(
                                                        e.target.value,
                                                      )
                                                    }
                                                    className="form-control"
                                                  />
                                                </td>
                                                <td>
                                                  {medUnit.unit
                                                    ? medUnit.unit
                                                    : ""}
                                                </td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>{medUnit.description}</td>

                                                <td className="text-center">
                                                  {/* <Link
                                            to={'/stockMed/' + medUnit._id}
                                            class='btn btn-sm btn-primary'
                                            data-toggle='modal'
                                            data-target='#edit_stock{{$list->id}}'
                                          >
                                            <FaAngleDoubleRight />
                                          </Link> */}
                                                  <button
                                                    onClick={(e) =>
                                                      handleMUpdate(medUnit)
                                                    }
                                                    class="btn btn-sm btn-dark mt-3"
                                                  //data-toggle='modal'
                                                  // data-target='#edit_stock{{$list->id}}'
                                                  >
                                                    <FaAngleDoubleRight />
                                                  </button>
                                                </td>
                                                <td>
                                                  <input
                                                    type="checkbox"
                                                    key={medUnit}
                                                    // value={isChecked}
                                                    //   checked={medUnit.find(
                                                    //     item =>
                                                    //       item._id === medUnit._id
                                                    //   )}
                                                    // />
                                                    onClick={(e) =>
                                                      handleMedCheck(
                                                        e,
                                                        medUnit,
                                                        "checkBox",
                                                      )
                                                    }
                                                  />
                                                </td>
                                              </tr>
                                            ),
                                          )}

                                        {hideMed &&
                                          medUnitLists.map((medUnit, i) => (
                                            <tr>
                                              <td>{++i}</td>
                                              <td>{medUnit.code}</td>
                                              <td>
                                                {medUnit.name
                                                  ? medUnit.name.relatedBrand
                                                    .name
                                                  : ""}
                                              </td>
                                              <td>
                                                {medUnit.medicineItemName}
                                              </td>
                                              <td>
                                                {medUnit.reOrderQuantity >=
                                                  medUnit.currentQuantity ? (
                                                  <input
                                                    type="number"
                                                    onWheel={(e) => {
                                                      e.preventDefault();
                                                      e.target.blur();
                                                    }}
                                                    defaultValue={Number(
                                                      medUnit?.currentQuantity,
                                                    ).toFixed(2)}
                                                    onChange={(e) =>
                                                      handleMUpdateUnitCalculation(
                                                        e.target.value,
                                                        medUnit,
                                                        "currentQuantity",
                                                      )
                                                    }
                                                    className="p-2 rounded-lg"
                                                    style={{
                                                      border: "1px solid red",
                                                    }}
                                                  />
                                                ) : (
                                                  <input
                                                    type="number"
                                                    onWheel={(e) => {
                                                      e.preventDefault();
                                                      e.target.blur();
                                                    }}
                                                    defaultValue={Number(
                                                      medUnit?.currentQuantity,
                                                    ).toFixed(2)}
                                                    onChange={(e) =>
                                                      handleMUpdateUnitCalculation(
                                                        e.target.value,
                                                        medUnit,
                                                        "currentQuantity",
                                                      )
                                                    }
                                                    className="p-2 rounded-lg"
                                                  />
                                                )}
                                              </td>
                                              <td>
                                                <input
                                                  type="number"
                                                  onWheel={(e) => {
                                                    e.preventDefault();
                                                    e.target.blur();
                                                  }}
                                                  defaultValue={
                                                    medUnit.fromUnit
                                                  }
                                                  disabled
                                                  className="p-2 rounded-lg"
                                                />
                                              </td>
                                              <td>
                                                <input
                                                  type="number"
                                                  onWheel={(e) => {
                                                    e.preventDefault();
                                                    e.target.blur();
                                                  }}
                                                  value={medUnit.toUnit}
                                                  onFocus={() => {
                                                    prevToUnitRef.current =
                                                      medUnit.toUnit;
                                                  }}
                                                  onChange={(e) =>
                                                    handleMUpdateUnitCalculation(
                                                      e.target.value,
                                                      medUnit,
                                                      "toUnit",
                                                    )
                                                  }
                                                  className="p-2 rounded-lg"
                                                />
                                              </td>
                                              <td>
                                                <input
                                                  type="number"
                                                  onWheel={(e) => {
                                                    e.preventDefault();
                                                    e.target.blur();
                                                  }}
                                                  value={Number(
                                                    medUnit.currentQuantity *
                                                    medUnit.toUnit,
                                                  ).toFixed(2)}
                                                  disabled
                                                  className="p-2 rounded-lg"
                                                />
                                              </td>
                                              {medUnit?.TCLSellingPrice ? (
                                                <td>
                                                  <input
                                                    type="number"
                                                    onWheel={(e) => {
                                                      e.preventDefault();
                                                      e.target.blur();
                                                    }}
                                                    defaultValue={
                                                      medUnit?.TCLSellingPrice
                                                    }
                                                    className="p-2 rounded-lg"
                                                    disabled
                                                  />
                                                </td>
                                              ) : (
                                                <td>
                                                  <input
                                                    type="text"
                                                    defaultValue={"Not Set"}
                                                    className="p-2 rounded-lg"
                                                    disabled
                                                  />
                                                </td>
                                              )}

                                              <td>
                                                <input
                                                  type="number"
                                                  onWheel={(e) => {
                                                    e.preventDefault();
                                                    e.target.blur();
                                                  }}
                                                  defaultValue={
                                                    medUnit.sellingPrice
                                                  }
                                                  onChange={(e) =>
                                                    setMSell(e.target.value)
                                                  }
                                                  className="p-2 rounded-lg"
                                                />
                                              </td>
                                              <td>
                                                <input
                                                  type="number"
                                                  onWheel={(e) => {
                                                    e.preventDefault();
                                                    e.target.blur();
                                                  }}
                                                  defaultValue={
                                                    medUnit.purchasePrice
                                                  }
                                                  onChange={(e) =>
                                                    setMPurchase(
                                                      e.target.value,
                                                    )
                                                  }
                                                  className="p-2 rounded-lg"
                                                />
                                              </td>
                                              <td>
                                                {medUnit.unit
                                                  ? medUnit.unit
                                                  : ""}
                                              </td>
                                              <td>0</td>
                                              <td>0</td>
                                              <td>0</td>
                                              <td>0</td>
                                              <td>{medUnit.description}</td>

                                              <td className="flex w-responsive">
                                                <span
                                                  onClick={(e) =>
                                                    handleMUpdate(medUnit)
                                                  }
                                                  className=" btn btn-sm btn-dark mt-3"
                                                >
                                                  <FaAngleDoubleRight />
                                                </span>
                                              </td>
                                              <td>
                                                <input
                                                  type="checkbox"
                                                  key={medUnit}
                                                  // value={isChecked}
                                                  //   checked={medUnit.find(
                                                  //     item =>
                                                  //       item._id === medUnit._id
                                                  //   )}
                                                  // />
                                                  onClick={(e) =>
                                                    handleMedCheck(
                                                      e,
                                                      medUnit,
                                                      "checkBox",
                                                    )
                                                  }
                                                />
                                              </td>
                                            </tr>
                                          ))}

                                        {showMedBranch &&
                                          medBranchLists
                                            .filter(
                                              (el) => el.isDeleted === false,
                                            )
                                            .map((medUnit, i) => (
                                              <tr>
                                                <td>{++i}</td>
                                                <td>
                                                  {medUnit.relatedMedicineItems
                                                    ? medUnit
                                                      .relatedMedicineItems
                                                      .code
                                                    : ""}
                                                </td>
                                                <td>
                                                  {medUnit.relatedMedicineItems
                                                    ? medUnit
                                                      .relatedMedicineItems
                                                      .name.relatedBrand
                                                      .name
                                                    : ""}
                                                </td>

                                                <td>
                                                  {medUnit.relatedMedicineItems
                                                    ? medUnit
                                                      .relatedMedicineItems
                                                      .medicineItemName
                                                    : ""}
                                                </td>
                                                <td>
                                                  <input
                                                    type="number"
                                                    onWheel={(e) => {
                                                      e.preventDefault();
                                                      e.target.blur();
                                                    }}
                                                    defaultValue={Number(
                                                      medUnit.currentQty,
                                                    ).toFixed(2)}
                                                    onChange={(e) =>
                                                      handleMBranchUpdateUnitCalculation(
                                                        e.target.value,
                                                        medUnit,
                                                        "currentQty",
                                                      )
                                                    }
                                                    className="p-2 rounded-lg"
                                                  />
                                                </td>
                                                <td>
                                                  <input
                                                    type="number"
                                                    onWheel={(e) => {
                                                      e.preventDefault();
                                                      e.target.blur();
                                                    }}
                                                    defaultValue={
                                                      medUnit.relatedMedicineItems
                                                        ? medUnit
                                                          .relatedMedicineItems
                                                          ?.fromUnit
                                                        : ""
                                                    }
                                                    className="p-2 rounded-lg"
                                                    disabled={true}
                                                  />
                                                </td>
                                                <td>
                                                  <input
                                                    type="number"
                                                    onWheel={(e) => {
                                                      e.preventDefault();
                                                      e.target.blur();
                                                    }}
                                                    defaultValue={
                                                      medUnit.relatedMedicineItems
                                                        ? medUnit
                                                          .relatedMedicineItems
                                                          .toUnit
                                                        : ""
                                                    }
                                                    onChange={(e) =>
                                                      handleMBranchUpdateUnitCalculation(
                                                        e.target.value,
                                                        medUnit,
                                                        "toUnit",
                                                      )
                                                    }
                                                    className="p-2 rounded-lg"
                                                    disabled={true}
                                                  />
                                                </td>
                                                <td>
                                                  <input
                                                    type="number"
                                                    onWheel={(e) => {
                                                      e.preventDefault();
                                                      e.target.blur();
                                                    }}
                                                    value={Number(
                                                      medUnit.currentQty *
                                                      medUnit
                                                        .relatedMedicineItems
                                                        ?.toUnit,
                                                    ).toFixed(2)}
                                                    disabled
                                                    className="p-2 rounded-lg"
                                                  />
                                                </td>
                                                {medUnit.relatedMedicineItems
                                                  ?.TCLSellingPrice ? (
                                                  <td>
                                                    <input
                                                      type="number"
                                                      onWheel={(e) => {
                                                        e.preventDefault();
                                                        e.target.blur();
                                                      }}
                                                      defaultValue={
                                                        medUnit.relatedMedicineItems
                                                          ? medUnit
                                                            .relatedMedicineItems
                                                            ?.TCLSellingPrice
                                                          : ""
                                                      }
                                                      onChange={(e) =>
                                                        setMSell(
                                                          e.target.value,
                                                        )
                                                      }
                                                      className="p-2 rounded-lg"
                                                      disabled
                                                    />
                                                  </td>
                                                ) : (
                                                  <td>
                                                    <input
                                                      type="text"
                                                      defaultValue={"Not Set"}
                                                      onChange={(e) =>
                                                        setMSell(
                                                          e.target.value,
                                                        )
                                                      }
                                                      className="p-2 rounded-lg"
                                                      disabled
                                                    />
                                                  </td>
                                                )}

                                                <td>
                                                  <input
                                                    type="number"
                                                    onWheel={(e) => {
                                                      e.preventDefault();
                                                      e.target.blur();
                                                    }}
                                                    defaultValue={
                                                      medUnit
                                                        .relatedMedicineItems
                                                        ?.sellingPrice
                                                        ? medUnit
                                                          .relatedMedicineItems
                                                          .sellingPrice
                                                        : ""
                                                    }
                                                    onChange={(e) =>
                                                      setMSell(e.target.value)
                                                    }
                                                    className="p-2 rounded-lg"
                                                  />
                                                </td>

                                                <td>
                                                  <input
                                                    type="number"
                                                    onWheel={(e) => {
                                                      e.preventDefault();
                                                      e.target.blur();
                                                    }}
                                                    defaultValue={
                                                      medUnit.relatedMedicineItems
                                                        ? medUnit
                                                          .relatedMedicineItems
                                                          .purchasePrice
                                                        : ""
                                                    }
                                                    onChange={(e) =>
                                                      setMPurchase(
                                                        e.target.value,
                                                      )
                                                    }
                                                    className="p-2 rounded-lg"
                                                  />
                                                </td>
                                                <td>
                                                  {medUnit.relatedMedicineItems
                                                    ? medUnit
                                                      .relatedMedicineItems
                                                      .unit
                                                    : ""}
                                                </td>
                                                <td>
                                                  <td>
                                                    {medUnit.relatedMedicineItems
                                                      ? medUnit
                                                        .relatedMedicineItems
                                                        .description
                                                      : ""}
                                                  </td>
                                                </td>
                                                <td className="text-center">
                                                  &nbsp;
                                                  <button
                                                    onClick={(e) =>
                                                      handleMBranchUpdate(
                                                        medUnit,
                                                      )
                                                    }
                                                    class="btn btn-sm btn-dark mt-3"
                                                  //data-toggle='modal'
                                                  // data-target='#edit_stock{{$list->id}}'
                                                  >
                                                    <FaAngleDoubleRight />
                                                  </button>
                                                </td>
                                              </tr>
                                            ))}
                                      </tbody>
                                    </>
                                  ) : (
                                    <div
                                      className="d-flex justify-content-center align-items-center"
                                      style={{
                                        minHeight: "500px",
                                        width: "90%",
                                      }}
                                    >
                                      <div className="text-center">
                                        <Spinner
                                          animation="border"
                                          variant="primary"
                                          style={{
                                            width: "3rem",
                                            height: "3rem",
                                          }}
                                        />
                                        <p className="mt-2 text-muted">
                                          Loading data...
                                        </p>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </table>
                            </div>
                          </div>
                        )}

                        {showProAss && (
                          <div>
                            {showProAccBranch ? (
                              ""
                            ) : (
                              <>
                                {accHOCount !== 0 && (
                                  <div>
                                    <div
                                      className="bg-warning"
                                      style={{
                                        padding: "15px",
                                        borderRadius: "5px",
                                        fontSize: "18px",
                                      }}
                                    >
                                      You have Expired Accessory Items :
                                      <b>{accHOCount}</b>. &nbsp;
                                      <Link
                                        to="/expDateList"
                                        className="text-decoration-underline text-white"
                                      >
                                        Check
                                      </Link>{" "}
                                    </div>
                                  </div>
                                )}
                                <div className="row  mb-3">
                                  <div className="col-md-2">
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-dark"
                                      onClick={excelExport3}
                                    >
                                      <FaFileExport />
                                      &nbsp; Export
                                    </button>
                                    &nbsp;
                                    {/* <button
                                          type='button'
                                          className='btn btn-sm btn-dark'
                                          onClick={() => setOpen(true)}
                                        >
                                          Data Entry
                                        </button> */}
                                  </div>
                                  <div className="col-md-3 mt-1">
                                    <b className="btn btn-sm btn-dark">
                                      Total Inventory Value :
                                      {proAssTotal.toFixed(2)} MMK
                                    </b>
                                  </div>

                                  <div className="offset-3 col-md-3 ">
                                    <input
                                      type="search"
                                      className="form-control rounded "
                                      style={{ borderRadius: "17px" }}
                                      onChange={(e) =>
                                        proAccSearch(e.target.value)
                                      }
                                      id="search_code"
                                      placeholder="Search Items"
                                    />
                                  </div>
                                </div>
                              </>
                            )}

                            <div className="table-responsive">
                              <table className="table table-hover">
                                <div style={scroll}>
                                  <thead
                                    className="sticky-top bg-light"
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    <tr>
                                      <th style={{ fontWeight: "400px" }}>
                                        #
                                      </th>
                                      <th style={{ fontWeight: "400px" }}>
                                        Code
                                      </th>
                                      <th>Brand</th>
                                      <th style={{ fontWeight: "400px" }}>
                                        Name
                                      </th>
                                      <th style={{ fontWeight: "400px" }}>
                                        Qty
                                      </th>
                                      <th style={{ fontWeight: "400px" }}>
                                        From Unit
                                      </th>
                                      <th style={{ fontWeight: "400px" }}>
                                        To Unit
                                      </th>
                                      <th style={{ fontWeight: "400px" }}>
                                        Total Unit
                                      </th>

                                      <th style={{ fontWeight: "400px" }}>
                                        TCL Sell
                                      </th>

                                      <th style={{ fontWeight: "400px" }}>
                                        Selling( MMK )
                                      </th>

                                      <th style={{ fontWeight: "400px" }}>
                                        Purchase( MMK )
                                      </th>
                                      <th style={{ fontWeight: "400px" }}>
                                        Unit
                                      </th>
                                      <th>Desc</th>
                                      <th
                                        className="text-center"
                                        style={{ fontWeight: "400px" }}
                                      >
                                        Action
                                      </th>
                                      {(hideProAcc || showProAccSearch) && (
                                        <th>
                                          Select All &nbsp;
                                          <input
                                            type="checkbox"
                                            onClick={(e) =>
                                              handleAccSelectAll(
                                                e,
                                                proAssLists,
                                                "checkBox",
                                              )
                                            }
                                          />
                                        </th>
                                      )}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {hideProAcc &&
                                      proAssLists.map((proAssUnit, i) => (
                                        <tr>
                                          <td>{++i}</td>
                                          <td>{proAssUnit.code}</td>
                                          <td>
                                            {proAssUnit.name.relatedBrand
                                              ? proAssUnit.name.relatedBrand
                                                .name
                                              : ""}
                                          </td>
                                          <td>
                                            {proAssUnit.accessoryItemName}
                                          </td>
                                          <td>
                                            {proAssUnit.reOrderQuantity >=
                                              proAssUnit.currentQuantity ? (
                                              <input
                                                type="number"
                                                onWheel={(e) => {
                                                  e.preventDefault();
                                                  e.target.blur();
                                                }}
                                                defaultValue={Number(
                                                  proAssUnit.currentQuantity,
                                                ).toFixed(2)}
                                                onChange={(e) =>
                                                  handlePAUpdateUnitCalculation(
                                                    e.target.value,
                                                    proAssUnit,
                                                    "currentQuantity",
                                                  )
                                                }
                                                className="p-2 rounded-lg"
                                                style={{
                                                  border: "1px solid red",
                                                }}
                                              />
                                            ) : (
                                              <input
                                                type="number"
                                                onWheel={(e) => {
                                                  e.preventDefault();
                                                  e.target.blur();
                                                }}
                                                defaultValue={Number(
                                                  proAssUnit.currentQuantity,
                                                ).toFixed(2)}
                                                onChange={(e) =>
                                                  handlePAUpdateUnitCalculation(
                                                    e.target.value,
                                                    proAssUnit,
                                                    "currentQuantity",
                                                  )
                                                }
                                                className="p-2 rounded-lg"
                                              />
                                            )}
                                          </td>
                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => {
                                                e.preventDefault();
                                                e.target.blur();
                                              }}
                                              defaultValue={
                                                proAssUnit.fromUnit
                                              }
                                              disabled
                                              className="p-2 rounded-lg"
                                            />
                                          </td>
                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => {
                                                e.preventDefault();
                                                e.target.blur();
                                              }}
                                              value={proAssUnit.toUnit}
                                              onFocus={() => {
                                                prevPAToUnitRef.current =
                                                  proAssUnit.toUnit;
                                              }}
                                              onChange={(e) =>
                                                handlePAUpdateUnitCalculation(
                                                  e.target.value,
                                                  proAssUnit,
                                                  "toUnit",
                                                )
                                              }
                                              className="p-2 rounded-lg"
                                            />
                                          </td>
                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => {
                                                e.preventDefault();
                                                e.target.blur();
                                              }}
                                              value={Number(
                                                (proAssUnit?.currentQuantity *
                                                  proAssUnit?.toUnit) /
                                                proAssUnit?.fromUnit,
                                              ).toFixed(2)}
                                              onFocus={() => {
                                                prevPAToUnitRef.current =
                                                  proAssUnit.toUnit;
                                              }}
                                              disabled
                                              className="p-2 rounded-lg"
                                            />
                                          </td>
                                          {proAssUnit?.TCLSellingPrice ? (
                                            <td>
                                              <input
                                                type="number"
                                                onWheel={(e) => {
                                                  e.preventDefault();
                                                  e.target.blur();
                                                }}
                                                defaultValue={
                                                  proAssUnit?.TCLSellingPrice
                                                }
                                                className="p-2 rounded-lg"
                                                disabled
                                              />
                                            </td>
                                          ) : (
                                            <td>
                                              <input
                                                type="text"
                                                defaultValue={"Not Set"}
                                                className="p-2 rounded-lg"
                                                disabled
                                              />
                                            </td>
                                          )}

                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => {
                                                e.preventDefault();
                                                e.target.blur();
                                              }}
                                              defaultValue={
                                                proAssUnit.sellingPrice
                                              }
                                              onChange={(e) =>
                                                setPASell(e.target.value)
                                              }
                                              className="p-2 rounded-lg"
                                            />
                                          </td>
                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => {
                                                e.preventDefault();
                                                e.target.blur();
                                              }}
                                              defaultValue={
                                                proAssUnit.purchasePrice
                                              }
                                              onChange={(e) =>
                                                setPAPurchase(e.target.value)
                                              }
                                              className="p-2 rounded-lg"
                                            />
                                          </td>
                                          <td>
                                            {proAssUnit.unit
                                              ? proAssUnit.unit
                                              : ""}
                                          </td>
                                          <td>{proAssUnit.description}</td>

                                          <td className="text-center">
                                            {/* <Link
                                            to={
                                              '/stockProAss/' + proAssUnit._id
                                            }
                                            class='btn btn-sm btn-primary'
                                            data-toggle='modal'
                                            data-target='#edit_stock{{$list->id}}'
                                          >
                                            <FaAngleDoubleRight />
                                          </Link> */}
                                            <button
                                              onClick={(e) =>
                                                handlePAUpdate(proAssUnit)
                                              }
                                              class="btn btn-sm btn-dark mt-3"
                                            //data-toggle='modal'
                                            // data-target='#edit_stock{{$list->id}}'
                                            >
                                              <FaAngleDoubleRight />
                                            </button>
                                          </td>
                                          <td>
                                            <input
                                              type="checkbox"
                                              key={proAssUnit}
                                              // value={isChecked}
                                              //   checked={medUnit.find(
                                              //     item =>
                                              //       item._id === medUnit._id
                                              //   )}
                                              // />
                                              onClick={(e) =>
                                                handleProAssCheck(
                                                  e,
                                                  proAssUnit,
                                                  "checkBox",
                                                )
                                              }
                                            />
                                          </td>
                                        </tr>
                                      ))}

                                    {showProAccBranch &&
                                      proAccBranchLists.map(
                                        (proAssUnit, i) => (
                                          <tr>
                                            <td>{++i}</td>
                                            <td>
                                              {proAssUnit.relatedAccessoryItems
                                                ? proAssUnit
                                                  .relatedAccessoryItems
                                                  .code
                                                : ""}
                                            </td>
                                            <td>
                                              {proAssUnit.relatedAccessoryItems
                                                ? proAssUnit
                                                  .relatedAccessoryItems
                                                  .name.relatedBrand.name
                                                : ""}
                                            </td>

                                            <td>
                                              {proAssUnit.relatedAccessoryItems
                                                ? proAssUnit
                                                  .relatedAccessoryItems
                                                  .accessoryItemName
                                                : ""}
                                            </td>
                                            <td>
                                              <input
                                                type="number"
                                                onWheel={(e) => {
                                                  e.preventDefault();
                                                  e.target.blur();
                                                }}
                                                defaultValue={Number(
                                                  proAssUnit.currentQty,
                                                ).toFixed(2)}
                                                onChange={(e) =>
                                                  handleProAssBranchUpdateUnitCalculation(
                                                    e.target.value,
                                                    proAssUnit,
                                                    "currentQty",
                                                  )
                                                }
                                                className="p-2 rounded-lg"
                                              />
                                            </td>
                                            <td>
                                              <input
                                                type="number"
                                                onWheel={(e) => {
                                                  e.preventDefault();
                                                  e.target.blur();
                                                }}
                                                defaultValue={
                                                  proAssUnit.relatedAccessoryItems
                                                    ? proAssUnit
                                                      .relatedAccessoryItems
                                                      .fromUnit
                                                    : ""
                                                }
                                                className="p-2 rounded-lg"
                                                disabled={true}
                                              />
                                            </td>
                                            <td>
                                              <input
                                                type="number"
                                                onWheel={(e) => {
                                                  e.preventDefault();
                                                  e.target.blur();
                                                }}
                                                value={
                                                  proAssUnit.relatedAccessoryItems
                                                    ? proAssUnit
                                                      .relatedAccessoryItems
                                                      .toUnit
                                                    : ""
                                                }
                                                onChange={(e) =>
                                                  handleProAssBranchUpdateUnitCalculation(
                                                    e.target.value,
                                                    proAssUnit,
                                                    "toUnit",
                                                  )
                                                }
                                                className="p-2 rounded-lg"
                                                disabled={true}
                                              />
                                            </td>
                                            <td>
                                              <input
                                                type="number"
                                                onWheel={(e) => {
                                                  e.preventDefault();
                                                  e.target.blur();
                                                }}
                                                value={Number(
                                                  proAssUnit.totalUnit,
                                                ).toFixed(2)}
                                                disabled
                                                className="p-2 rounded-lg"
                                              />
                                            </td>
                                            {proAssUnit.relatedAccessoryItems
                                              .TCLSellingPrice ? (
                                              <td>
                                                <input
                                                  type="number"
                                                  onWheel={(e) => {
                                                    e.preventDefault();
                                                    e.target.blur();
                                                  }}
                                                  value={
                                                    proAssUnit.relatedAccessoryItems
                                                      ? proAssUnit
                                                        .relatedAccessoryItems
                                                        .TCLSellingPrice
                                                      : ""
                                                  }
                                                  onChange={(e) =>
                                                    setMSell(e.target.value)
                                                  }
                                                  className="p-2 rounded-lg"
                                                  disabled
                                                />
                                              </td>
                                            ) : (
                                              <td>
                                                <input
                                                  type="text"
                                                  value={"Not Set"}
                                                  onChange={(e) =>
                                                    setMSell(e.target.value)
                                                  }
                                                  className="p-2 rounded-lg"
                                                  disabled
                                                />
                                              </td>
                                            )}

                                            <td>
                                              <input
                                                type="number"
                                                onWheel={(e) => {
                                                  e.preventDefault();
                                                  e.target.blur();
                                                }}
                                                value={
                                                  proAssUnit
                                                    .relatedAccessoryItems
                                                    ?.sellingPrice
                                                    ? proAssUnit
                                                      .relatedAccessoryItems
                                                      .sellingPrice
                                                    : ""
                                                }
                                                onChange={(e) =>
                                                  setPASell(e.target.value)
                                                }
                                                className="p-2 rounded-lg"
                                              />
                                            </td>
                                            <td>
                                              <input
                                                type="number"
                                                onWheel={(e) => {
                                                  e.preventDefault();
                                                  e.target.blur();
                                                }}
                                                value={
                                                  proAssUnit.relatedAccessoryItems
                                                    ? proAssUnit
                                                      .relatedAccessoryItems
                                                      .purchasePrice
                                                    : ""
                                                }
                                                onChange={(e) =>
                                                  setPAPurchase(
                                                    e.target.value,
                                                  )
                                                }
                                                className="p-2 rounded-lg"
                                              />
                                            </td>
                                            <td>
                                              {proAssUnit.relatedAccessoryItems
                                                ? proAssUnit
                                                  .relatedAccessoryItems
                                                  .unit
                                                : ""}
                                            </td>
                                            <td>
                                              {proAssUnit.relatedAccessoryItems
                                                ? proAssUnit
                                                  .relatedAccessoryItems
                                                  .description
                                                : ""}
                                            </td>

                                            <td className="text-center">
                                              &nbsp;
                                              <button
                                                onClick={(e) =>
                                                  handleProAssBranchUpdate(
                                                    proAssUnit,
                                                  )
                                                }
                                                className="btn btn-sm btn-dark mt-3"
                                              //data-toggle='modal'
                                              // data-target='#edit_stock{{$list->id}}'
                                              >
                                                <FaAngleDoubleRight />
                                              </button>
                                            </td>
                                          </tr>
                                        ),
                                      )}

                                    {showProAccSearch &&
                                      searchProAccResults.map(
                                        (proAssUnit, i) => (
                                          <>
                                            <tr>
                                              <td>{++i}</td>
                                              <td>{proAssUnit.code}</td>
                                              <td>
                                                {proAssUnit.name.relatedBrand
                                                  ? proAssUnit.name
                                                    .relatedBrand.name
                                                  : ""}
                                              </td>
                                              <td>
                                                {proAssUnit.accessoryItemName}
                                              </td>
                                              <td>
                                                <input
                                                  type="number"
                                                  onWheel={(e) => {
                                                    e.preventDefault();
                                                    e.target.blur();
                                                  }}
                                                  value={Number(
                                                    proAssUnit.currentQuantity,
                                                  ).toFixed(2)}
                                                  onChange={(e) =>
                                                    handlePASearchUpdateUnitCalculation(
                                                      e.target.value,
                                                      proAssUnit,
                                                      "currentQuantity",
                                                    )
                                                  }
                                                  className="p-2 rounded-lg"
                                                />
                                              </td>
                                              <td>
                                                <input
                                                  type="number"
                                                  onWheel={(e) => {
                                                    e.preventDefault();
                                                    e.target.blur();
                                                  }}
                                                  defaultValue={
                                                    proAssUnit.fromUnit
                                                  }
                                                  disabled
                                                  className="p-2 rounded-lg"
                                                />
                                              </td>
                                              <td>
                                                <input
                                                  type="number"
                                                  onWheel={(e) => {
                                                    e.preventDefault();
                                                    e.target.blur();
                                                  }}
                                                  value={proAssUnit.toUnit}
                                                  onChange={(e) =>
                                                    handlePASearchUpdateUnitCalculation(
                                                      e.target.value,
                                                      proAssUnit,
                                                      "toUnit",
                                                    )
                                                  }
                                                  className="p-2 rounded-lg"
                                                />
                                              </td>
                                              <td>
                                                <input
                                                  type="number"
                                                  onWheel={(e) => {
                                                    e.preventDefault();
                                                    e.target.blur();
                                                  }}
                                                  value={Number(
                                                    (proAssUnit?.currentQuantity *
                                                      proAssUnit?.toUnit) /
                                                    proAssUnit?.fromUnit,
                                                  ).toFixed(2)}
                                                  onFocus={() => {
                                                    prevPAToUnitRef.current =
                                                      proAssUnit.toUnit;
                                                  }}
                                                  disabled
                                                  className="p-2 rounded-lg"
                                                />
                                              </td>
                                              {proAssUnit?.TCLSellingPrice ? (
                                                <td>
                                                  <input
                                                    type="number"
                                                    onWheel={(e) => {
                                                      e.preventDefault();
                                                      e.target.blur();
                                                    }}
                                                    value={
                                                      proAssUnit?.TCLSellingPrice
                                                    }
                                                    className="p-2 rounded-lg"
                                                    disabled
                                                  />
                                                </td>
                                              ) : (
                                                <td>
                                                  <input
                                                    type="text"
                                                    defaultValue={"Not Set"}
                                                    className="p-2 rounded-lg"
                                                    disabled
                                                  />
                                                </td>
                                              )}

                                              <td>
                                                <input
                                                  type="number"
                                                  onWheel={(e) => {
                                                    e.preventDefault();
                                                    e.target.blur();
                                                  }}
                                                  value={
                                                    proAssUnit.sellingPrice
                                                  }
                                                  onChange={(e) =>
                                                    setPASell(e.target.value)
                                                  }
                                                  className="p-2 rounded-lg"
                                                />
                                              </td>
                                              <td>
                                                <input
                                                  type="number"
                                                  onWheel={(e) => {
                                                    e.preventDefault();
                                                    e.target.blur();
                                                  }}
                                                  value={
                                                    proAssUnit.purchasePrice
                                                  }
                                                  disabled
                                                  onChange={(e) =>
                                                    setPAPurchase(
                                                      e.target.value,
                                                    )
                                                  }
                                                  className="p-2 rounded-lg"
                                                />
                                              </td>
                                              <td>
                                                {proAssUnit.unit
                                                  ? proAssUnit.unit
                                                  : ""}
                                              </td>
                                              <td>
                                                {proAssUnit.description}
                                              </td>

                                              <td className="text-center">
                                                {/* <Link
                                            to={
                                              '/stockProAss/' + proAssUnit._id
                                            }
                                            class='btn btn-sm btn-primary'
                                            data-toggle='modal'
                                            data-target='#edit_stock{{$list->id}}'
                                          >
                                            <FaAngleDoubleRight />
                                          </Link> */}
                                                <button
                                                  onClick={(e) =>
                                                    handlePAUpdate(proAssUnit)
                                                  }
                                                  class="btn btn-sm btn-dark mt-3"
                                                //data-toggle='modal'
                                                // data-target='#edit_stock{{$list->id}}'
                                                >
                                                  <FaAngleDoubleRight />
                                                </button>
                                              </td>
                                              <td>
                                                <input
                                                  type="checkbox"
                                                  key={proAssUnit}
                                                  // value={isChecked}
                                                  //   checked={medUnit.find(
                                                  //     item =>
                                                  //       item._id === medUnit._id
                                                  //   )}
                                                  // />
                                                  onClick={(e) =>
                                                    handleProAssCheck(
                                                      e,
                                                      proAssUnit,
                                                      "checkBox",
                                                    )
                                                  }
                                                />
                                              </td>
                                            </tr>
                                          </>
                                        ),
                                      )}
                                  </tbody>
                                </div>
                              </table>
                            </div>
                          </div>
                        )}

                        {showGeneral && (
                          <div>
                            {generalBranch ? (
                              ""
                            ) : (
                              <>
                                {genHOCount !== 0 && (
                                  <div>
                                    <div
                                      className="bg-warning "
                                      style={{
                                        padding: "15px",
                                        borderRadius: "5px",
                                        fontSize: "18px",
                                      }}
                                    >
                                      You have Expired General Items :
                                      <b>{genHOCount}</b>. &nbsp;
                                      <Link
                                        to="/expDateList"
                                        className="text-decoration-underline text-white"
                                      >
                                        Check
                                      </Link>{" "}
                                    </div>
                                  </div>
                                )}
                                <div className="row  mb-3">
                                  <div className="col-md-2">
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-dark"
                                      onClick={excelExport4}
                                    >
                                      <FaFileExport />
                                      &nbsp; Export
                                    </button>
                                    &nbsp;
                                    {/* <button
                                          type='button'
                                          className='btn btn-sm btn-dark'
                                          onClick={() => setOpen(true)}
                                        >
                                          Data Entry
                                        </button> */}
                                  </div>
                                  <div className="col-md-3 mt-1">
                                    <b className="btn btn-sm btn-dark">
                                      Total Inventory Value :
                                      {Number(generalTotal)?.toFixed(2)} MMK
                                    </b>
                                  </div>

                                  <div className="offset-3 col-md-3 ">
                                    <input
                                      type="search"
                                      className="form-control rounded "
                                      style={{ borderRadius: "17px" }}
                                      onChange={(e) =>
                                        generalSearch(e.target.value)
                                      }
                                      id="search_code"
                                      placeholder="Search Items"
                                    />
                                  </div>
                                </div>
                              </>
                            )}

                            <div className="table-responsive">
                              <table className="table table-hover">
                                <div style={scroll}>
                                  <thead
                                    className="sticky-top bg-light"
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    <tr>
                                      <th style={{ fontWeight: "400px" }}>
                                        #
                                      </th>
                                      <th style={{ fontWeight: "400px" }}>
                                        Code
                                      </th>
                                      <th>Brand</th>
                                      <th style={{ fontWeight: "400px" }}>
                                        Name
                                      </th>
                                      <th style={{ fontWeight: "400px" }}>
                                        Qty
                                      </th>
                                      <th style={{ fontWeight: "400px" }}>
                                        From Unit
                                      </th>
                                      <th style={{ fontWeight: "400px" }}>
                                        To Unit
                                      </th>
                                      <th style={{ fontWeight: "400px" }}>
                                        Total Unit
                                      </th>
                                      <th style={{ fontWeight: "400px" }}>
                                        TCL Sell
                                      </th>
                                      <th style={{ fontWeight: "400px" }}>
                                        Selling( MMK )
                                      </th>
                                      <th style={{ fontWeight: "400px" }}>
                                        Purchase( MMK )
                                      </th>
                                      <th style={{ fontWeight: "400px" }}>
                                        Unit
                                      </th>
                                      <th>Desc</th>
                                      <th
                                        className="text-center"
                                        style={{ fontWeight: "400px" }}
                                      >
                                        Action
                                      </th>
                                      {generalTable && (
                                        <th>
                                          Select &nbsp;
                                          <input
                                            type="checkbox"
                                            onClick={(e) =>
                                              handleGenSelectAll(
                                                e,
                                                generalLists,
                                                "checkBox",
                                              )
                                            }
                                          />
                                        </th>
                                      )}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {generalTable &&
                                      generalLists.map((genUnit, i) => (
                                        <tr>
                                          <td>{++i}</td>
                                          <td>{genUnit.code}</td>
                                          <td>
                                            {genUnit.name.relatedBrand
                                              ? genUnit.name.relatedBrand.name
                                              : ""}
                                          </td>
                                          <td>
                                            {genUnit.accessoryItemName ||
                                              genUnit.generalItemName}
                                          </td>
                                          <td>
                                            {genUnit.reOrderQuantity >=
                                              genUnit.currentQuantity ? (
                                              <input
                                                type="number"
                                                onWheel={(e) => {
                                                  e.preventDefault();
                                                  e.target.blur();
                                                }}
                                                defaultValue={Number(
                                                  genUnit.currentQuantity,
                                                ).toFixed(2)}
                                                onChange={(e) =>
                                                  handleGeneralUpdateUnitCalculation(
                                                    e.target.value,
                                                    genUnit,
                                                    "currentQuantity",
                                                  )
                                                }
                                                className="p-2 rounded-lg"
                                                style={{
                                                  border: "1px solid red",
                                                }}
                                              />
                                            ) : (
                                              <input
                                                type="number"
                                                onWheel={(e) => {
                                                  e.preventDefault();
                                                  e.target.blur();
                                                }}
                                                defaultValue={Number(
                                                  genUnit.currentQuantity,
                                                ).toFixed(2)}
                                                onChange={(e) =>
                                                  handleGeneralUpdateUnitCalculation(
                                                    e.target.value,
                                                    genUnit,
                                                    "currentQuantity",
                                                  )
                                                }
                                                className="p-2 rounded-lg"
                                              />
                                            )}
                                          </td>
                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => {
                                                e.preventDefault();
                                                e.target.blur();
                                              }}
                                              defaultValue={genUnit.fromUnit}
                                              disabled
                                              className="p-2 rounded-lg"
                                            />
                                          </td>
                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => {
                                                e.preventDefault();
                                                e.target.blur();
                                              }}
                                              value={genUnit.toUnit}
                                              onFocus={() => {
                                                prevGeneralToUnitRef.current =
                                                  genUnit.toUnit;
                                              }}
                                              onChange={(e) =>
                                                handleGeneralUpdateUnitCalculation(
                                                  e.target.value,
                                                  genUnit,
                                                  "toUnit",
                                                )
                                              }
                                              className="p-2 rounded-lg"
                                            />
                                          </td>
                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => {
                                                e.preventDefault();
                                                e.target.blur();
                                              }}
                                              value={Number(
                                                genUnit.totalUnit,
                                              ).toFixed(2)}
                                              disabled
                                              className="p-2 rounded-lg"
                                            />
                                          </td>
                                          {genUnit?.TCLSellingPrice ? (
                                            <td>
                                              <input
                                                type="number"
                                                onWheel={(e) => {
                                                  e.preventDefault();
                                                  e.target.blur();
                                                }}
                                                defaultValue={
                                                  genUnit?.TCLSellingPrice
                                                }
                                                className="p-2 rounded-lg"
                                                disabled
                                              />
                                            </td>
                                          ) : (
                                            <td>
                                              <input
                                                type="text"
                                                defaultValue={"Not Set"}
                                                className="p-2 rounded-lg"
                                                disabled
                                              />
                                            </td>
                                          )}
                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => {
                                                e.preventDefault();
                                                e.target.blur();
                                              }}
                                              defaultValue={
                                                genUnit.sellingPrice
                                              }
                                              onChange={(e) =>
                                                setGenSell(e.target.value)
                                              }
                                              className="p-2 rounded-lg"
                                            />
                                          </td>
                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => {
                                                e.preventDefault();
                                                e.target.blur();
                                              }}
                                              defaultValue={
                                                genUnit.purchasePrice
                                              }
                                              onChange={(e) =>
                                                setGenPurchase(e.target.value)
                                              }
                                              className="p-2 rounded-lg"
                                            />
                                          </td>
                                          <td>
                                            {genUnit.unit ? genUnit.unit : ""}
                                          </td>
                                          <td>{genUnit.description}</td>

                                          <td className="text-center">
                                            {/* <Link
                                            to={
                                              '/stockProAss/' + genUnit._id
                                            }
                                            class='btn btn-sm btn-primary'
                                            data-toggle='modal'
                                            data-target='#edit_stock{{$list->id}}'
                                          >
                                            <FaAngleDoubleRight />
                                          </Link> */}
                                            <button
                                              onClick={(e) =>
                                                handleGeneralUpdate(genUnit)
                                              }
                                              class="btn btn-sm btn-dark mt-3"
                                            //data-toggle='modal'
                                            // data-target='#edit_stock{{$list->id}}'
                                            >
                                              <FaAngleDoubleRight />
                                            </button>
                                          </td>
                                          <td>
                                            <input
                                              type="checkbox"
                                              key={genUnit}
                                              // value={isChecked}
                                              //   checked={medUnit.find(
                                              //     item =>
                                              //       item._id === medUnit._id
                                              //   )}
                                              // />
                                              onClick={(e) =>
                                                handleGeneralCheck(
                                                  e,
                                                  genUnit,
                                                  "checkBox",
                                                )
                                              }
                                            />
                                          </td>
                                        </tr>
                                      ))}
                                    {/* {console.log(generalBranchLists, 'gen list')} */}
                                    {generalBranch &&
                                      generalBranchLists.map((genUnit, i) => (
                                        <tr>
                                          <td>{++i}</td>
                                          <td>
                                            {genUnit.relatedGeneralItems
                                              ? genUnit.relatedGeneralItems
                                                .code
                                              : ""}
                                          </td>
                                          <td>
                                            {genUnit.relatedGeneralItems
                                              ? genUnit.relatedGeneralItems
                                                .name.relatedBrand.name
                                              : ""}
                                          </td>

                                          <td>
                                            {genUnit.relatedGeneralItems
                                              ? genUnit.relatedGeneralItems
                                                .generalItemName ||
                                              genUnit.relatedGeneralItems
                                                .accessoryItemName
                                              : ""}
                                          </td>
                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => {
                                                e.preventDefault();
                                                e.target.blur();
                                              }}
                                              defaultValue={Number(
                                                genUnit.currentQty,
                                              )?.toFixed(2)}
                                              onChange={(e) =>
                                                handleGeneralBranchUpdateUnitCalculation(
                                                  e.target.value,
                                                  genUnit,
                                                  "currentQty",
                                                )
                                              }
                                              className="p-2 rounded-lg"
                                            />
                                          </td>
                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => {
                                                e.preventDefault();
                                                e.target.blur();
                                              }}
                                              defaultValue={
                                                genUnit.relatedGeneralItems
                                                  ? genUnit
                                                    .relatedGeneralItems
                                                    .fromUnit
                                                  : ""
                                              }
                                              className="p-2 rounded-lg"
                                              disabled={true}
                                            />
                                          </td>
                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => {
                                                e.preventDefault();
                                                e.target.blur();
                                              }}
                                              defaultValue={
                                                genUnit.relatedGeneralItems
                                                  ? genUnit
                                                    .relatedGeneralItems
                                                    .toUnit
                                                  : ""
                                              }
                                              onChange={(e) =>
                                                handleGeneralBranchUpdateUnitCalculation(
                                                  e.target.value,
                                                  genUnit,
                                                  "toUnit",
                                                )
                                              }
                                              className="p-2 rounded-lg"
                                              disabled={true}
                                            />
                                          </td>
                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => {
                                                e.preventDefault();
                                                e.target.blur();
                                              }}
                                              value={genUnit.totalUnit?.toFixed(
                                                2,
                                              )}
                                              disabled
                                              className="p-2 rounded-lg"
                                            />
                                          </td>
                                          {genUnit?.TCLSellingPrice ? (
                                            <td>
                                              <input
                                                type="number"
                                                onWheel={(e) => {
                                                  e.preventDefault();
                                                  e.target.blur();
                                                }}
                                                defaultValue={
                                                  genUnit?.TCLSellingPrice
                                                }
                                                className="p-2 rounded-lg"
                                                disabled
                                              />
                                            </td>
                                          ) : (
                                            <td>
                                              <input
                                                type="text"
                                                defaultValue={"Not Set"}
                                                className="p-2 rounded-lg"
                                                disabled
                                              />
                                            </td>
                                          )}
                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => {
                                                e.preventDefault();
                                                e.target.blur();
                                              }}
                                              defaultValue={
                                                genUnit.relatedGeneralItems
                                                  ? genUnit
                                                    .relatedGeneralItems
                                                    .sellingPrice
                                                  : ""
                                              }
                                              onChange={(e) =>
                                                setGenSell(e.target.value)
                                              }
                                              className="p-2 rounded-lg"
                                            />
                                          </td>
                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => {
                                                e.preventDefault();
                                                e.target.blur();
                                              }}
                                              defaultValue={
                                                genUnit.relatedGeneralItems
                                                  ? genUnit
                                                    .relatedGeneralItems
                                                    .purchasePrice
                                                  : ""
                                              }
                                              onChange={(e) =>
                                                setGenPurchase(e.target.value)
                                              }
                                              className="p-2 rounded-lg"
                                            />
                                          </td>
                                          <td>
                                            {genUnit.relatedGeneralItems
                                              ? genUnit.relatedGeneralItems
                                                .unit
                                              : ""}
                                          </td>
                                          <td>
                                            {genUnit.relatedGeneralItems
                                              ? genUnit.relatedGeneralItems
                                                .description
                                              : ""}
                                          </td>

                                          <td className="text-center">
                                            {/* <button
                                                onClick={() =>
                                                  handleDelGen(genUnit._id)
                                                }
                                                className='btn btn-sm btn-danger mt-3'
                                                data-toggle='modal'
                                                data-target='#edit_stock{{$list->id}}'
                                              >
                                                <FaTrashAlt />
                                              </button>{' '} */}
                                            &nbsp;
                                            <button
                                              onClick={(e) =>
                                                handleGeneralBranchUpdate(
                                                  genUnit,
                                                )
                                              }
                                              className="btn btn-sm btn-dark mt-3"
                                            //data-toggle='modal'
                                            // data-target='#edit_stock{{$list->id}}'
                                            >
                                              <FaAngleDoubleRight />
                                            </button>
                                          </td>
                                        </tr>
                                      ))}

                                    {showGeneralSearch &&
                                      searchGeneralResults.map(
                                        (genUnit, i) => (
                                          <tr>
                                            <td>{++i}</td>
                                            <td>{genUnit.code}</td>
                                            <td>
                                              {genUnit.name.relatedBrand
                                                ? genUnit.name.relatedBrand
                                                  .name
                                                : ""}
                                            </td>

                                            <td>
                                              {genUnit?.generalItemName ||
                                                genUnit?.accessoryItemName}
                                            </td>
                                            <td>
                                              <input
                                                type="number"
                                                onWheel={(e) => {
                                                  e.preventDefault();
                                                  e.target.blur();
                                                }}
                                                defaultValue={genUnit.currentQuantity?.toFixed(
                                                  2,
                                                )}
                                                onChange={(e) =>
                                                  handleGeneralSearchUpdateUnitCalculation(
                                                    e.target.value,
                                                    genUnit,
                                                    "currentQuantity",
                                                  )
                                                }
                                                className="p-2 rounded-lg"
                                              />
                                            </td>
                                            <td>
                                              <input
                                                type="number"
                                                onWheel={(e) => {
                                                  e.preventDefault();
                                                  e.target.blur();
                                                }}
                                                defaultValue={
                                                  genUnit.fromUnit
                                                }
                                                disabled
                                                className="p-2 rounded-lg"
                                              />
                                            </td>
                                            <td>
                                              <input
                                                type="number"
                                                onWheel={(e) => {
                                                  e.preventDefault();
                                                  e.target.blur();
                                                }}
                                                value={genUnit.toUnit}
                                                onFocus={() => {
                                                  prevGeneralToUnitRef.current =
                                                    genUnit.toUnit;
                                                }}
                                                onChange={(e) =>
                                                  handleGeneralSearchUpdateUnitCalculation(
                                                    e.target.value,
                                                    genUnit,
                                                    "toUnit",
                                                  )
                                                }
                                                className="p-2 rounded-lg"
                                              />
                                            </td>
                                            <td>
                                              <input
                                                type="number"
                                                onWheel={(e) => {
                                                  e.preventDefault();
                                                  e.target.blur();
                                                }}
                                                value={genUnit.totalUnit?.toFixed(
                                                  2,
                                                )}
                                                disabled
                                                className="p-2 rounded-lg"
                                              />
                                            </td>
                                            {genUnit?.TCLSellingPrice ? (
                                              <td>
                                                <input
                                                  type="number"
                                                  onWheel={(e) => {
                                                    e.preventDefault();
                                                    e.target.blur();
                                                  }}
                                                  defaultValue={
                                                    genUnit?.TCLSellingPrice
                                                  }
                                                  className="p-2 rounded-lg"
                                                  disabled
                                                />
                                              </td>
                                            ) : (
                                              <td>
                                                <input
                                                  type="text"
                                                  defaultValue={"Not Set"}
                                                  className="p-2 rounded-lg"
                                                  disabled
                                                />
                                              </td>
                                            )}
                                            <td>
                                              <input
                                                type="number"
                                                onWheel={(e) => {
                                                  e.preventDefault();
                                                  e.target.blur();
                                                }}
                                                defaultValue={
                                                  genUnit.sellingPrice
                                                }
                                                onChange={(e) =>
                                                  setGenSell(e.target.value)
                                                }
                                                className="p-2 rounded-lg"
                                              />
                                            </td>
                                            <td>
                                              <input
                                                type="number"
                                                onWheel={(e) => {
                                                  e.preventDefault();
                                                  e.target.blur();
                                                }}
                                                defaultValue={
                                                  genUnit.purchasePrice
                                                }
                                                onChange={(e) =>
                                                  setGenPurchase(
                                                    e.target.value,
                                                  )
                                                }
                                                className="p-2 rounded-lg"
                                              />
                                            </td>
                                            <td>
                                              {genUnit.unit
                                                ? genUnit.unit
                                                : ""}
                                            </td>
                                            <td>{genUnit.description}</td>

                                            <td className="text-center">
                                              {/* <Link
                                            to={
                                              '/stockProAss/' + genUnit._id
                                            }
                                            class='btn btn-sm btn-primary'
                                            data-toggle='modal'
                                            data-target='#edit_stock{{$list->id}}'
                                          >
                                            <FaAngleDoubleRight />
                                          </Link> */}
                                              <button
                                                onClick={(e) =>
                                                  handleGeneralUpdate(genUnit)
                                                }
                                                class="btn btn-sm btn-dark mt-3"
                                              //data-toggle='modal'
                                              // data-target='#edit_stock{{$list->id}}'
                                              >
                                                <FaAngleDoubleRight />
                                              </button>
                                            </td>
                                          </tr>
                                        ),
                                      )}
                                  </tbody>
                                </div>
                              </table>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <StockCountModal
              open={open}
              close={() => setOpen(false)}
              branchesLists={branchesLists}
              setOpen={setOpen}
            />
          </div>
        </section>
      </div>

    </>
  );
}
export default Stock;
